<template>
  <div id="box">
    <div class="delayWarn" v-show="networkTips">
      <i class="el-icon-warning-outline"></i>{{$t('coordinationParticipant.commentatorAbnormalNet')}}<el-button
        @click="refreshPage"
        icon="el-icon-refresh-right"
        >{{$t('coordinationParticipant.refresh')}}</el-button
      >
    </div>
    <div id="content">
      <Group
        ref="mainWindowContent"
        modeKey="mainWindow"
        title="Main window"
        :metaDataTimeCode="metaDataTimeCode"
        :metaDateTimeStamp="metaDateTimeStamp"
        :seiInfo="seiInfo"
        :meInfo="meInfo"
        :showTitle="false"
        :userInfo="userInfo"
        :rtc="rtc[externalPartyCode]"
        :channels="externalChannel"
        :nickNameInfo="nickNameInfo"
        :videoObj="videoObj"
        :amStatusInfo ="amStatusInfo"
        :allPairStatusInfo="allPairStatusInfo"
        :muteAudioObj="muteAudioObj"
        :muteAudioSelf="muteAudioSelf"
        :pgmMute="pgmMute"
        :userNewFullScreen="true"
        @callback="groupCallback"
      >
      </Group>
      <Group
        ref="talentCommentator"
        title="Talent Commentator"
        :meInfo="meInfo"
        :userInfo="userInfo"
        :channels="channels"
        :privateInfo="privateInfo"
        :showTitle="false"
        :userNewFullScreen="true"
        :isPrivate="isPrivate"
        :rtc="rtc[realPartyCode]"
        :nickNameInfo="nickNameInfo"
        :videoObj="videoObj"
        :muteAudioObj="muteAudioObj"
        :videoSelf="videoSelf"
        :muteAudioSelf="muteAudioSelf"
        @callback="groupCallback"
      />
      <!-- 按照最新需求 host 为多个 -->
      <AttendUser
        v-for="val in hostInfo"
        :key="val.id"
        class="is-local hide"
        nickName=""
        :rtc="rtc[realPartyCode]"
        :singChannel="hostInfo[val.id]"
        :userInfo="userInfo"
      >
      </AttendUser>
      <div class="foot" v-show="State.showFootBar">
        <div class="optionBox">
          <div class="metadata-controls" v-show = "showOffSetBtn">
            <el-button @click="adjustTimestamp(100)">+100ms</el-button>
            <el-button @click="adjustTimestamp(-100)">-100ms</el-button>
            <div class="offsetContent">offset: {{ timestampOffset }} ms</div>
          </div>
          <!-- 离开会议区域 -->
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('coordinationParticipant.leaveParty')"
            placement="top"
          >
            <i
              class="iconfont hangup pointer"
              @click="showDialog"
              @mouseenter="hangupHover = true"
              @mouseleave="hangupHover = false"
            >
              <!-- 挂断 -->
              <svg class="iconfont hangup" aria-hidden="true">
                <use v-if="!hangupHover" xlink:href="#icon-toolbarLeave"></use>
                <use v-if="hangupHover" xlink:href="#icon-toolbarLeave"></use>
              </svg>
            </i>
          </el-tooltip>
          <el-divider class="leaveDivider" direction="vertical"></el-divider>
          <!-- 控制摄像头的区域 -->
          <div class="m_r_40">
            <el-tooltip
              class="cameraItem"
              effect="dark"
              :content="$t('coordinationParticipant.turnOffCamera')"
              placement="top"
              v-if="videoSelf"
            >
              <i
                class="pointer iconfont icon-universal_cameraon"
                :class="{
                  m_r_0:  devicesInfo && devicesInfo.cameraList && devicesInfo.cameraList.length && rtcLoaded
                }"
                @click="setOperate({ type: 'muteVideo', id: userInfo.rtilCode })"
              >
              </i>
            </el-tooltip>
            <el-tooltip
              class="cameraItem"
              effect="dark"
              :content="$t('coordinationParticipant.turnOnCamera')"
              placement="top"
              v-if="!videoSelf"
            >
              <i
                class="iconfont pointer icon-universal_cameraoff"
                :class="{
                  m_r_0:
                    devicesInfo &&
                    devicesInfo.cameraList &&
                    devicesInfo.cameraList.length &&
                    rtcLoaded,
                    active: !videoSelf
                }"
                @click="setOperate({ type: 'muteVideo', id: userInfo.rtilCode })"
              >
              </i>
            </el-tooltip>
            <device-select
              v-if="
                devicesInfo &&
                devicesInfo.cameraList &&
                devicesInfo.cameraList.length &&
                rtcLoaded
              "
              title="Select a Camera"
              @updateDeviceId="updateDeviceId"
              @changeDevice="changeDevice"
              type="video"
              :deviceSelectId="devicesInfo.cameraId"
              :data="devicesInfo && devicesInfo.cameraList"
            />
          </div>
          <!-- 控制网页声音区域 -->
          <el-tooltip
            class="speakerItem"
            effect="dark"
            :content="speakerTitle"
            placement="top"
          >
            <i
              class="pointer iconfont icon-speakeron"
              @click="changeMute(isMute)"
              v-if="!isMute"
            ></i>
            <i
              :class="{active: isMute}"
              class="pointer iconfont icon-speakeroff"
              @click="changeMute(isMute)"
              v-else
            ></i>
          </el-tooltip>
          <device-select
          v-if="
            devicesInfo.speakerList &&
              devicesInfo.speakerList.length &&
              rtcLoaded
          "
          title="Select a Speaker"
          @updateDeviceId="updateDeviceId"
          @changeDevice="changeDevice"
          type="speaker"
          :deviceSelectId="devicesInfo.speakerId"
          :data="devicesInfo.speakerList"
        />
          <!-- 分割线 -->
          <el-divider direction="vertical"></el-divider>
          <!-- push to talk 区域 -->
          <el-tooltip
            class="micOnItem"
            effect="dark"
            :content="micTitle"
            placement="top"
          >
            <i
              class="iconfont pointer"
              :class="{
                m_r_0:
                  devicesInfo.microphoneList &&
                  devicesInfo.microphoneList.length &&
                  rtcLoaded,
                audioIcon:hadPushTalk,
                muteAudio:!hadPushTalk
              }"
              @click="setOperate({ type: 'muteAudio', id: userInfo.rtilCode })"
            >
              <i class="el-icon-warning" v-show="osLevelmicMuted && hadPushTalk"></i>
               <span style="width:40px; height:40px; display:inline-block;">
                <i v-if="hadPushTalk" style="font-size:28px;border:0; " :style="{'color':(hasTalkback||hasHostTalkback||hasPipTalkback) ?'#6D6D6D':'#33AB4F'}"
                 :class="{'iconfont icon-micOff':(hasTalkback||hasHostTalkback||hasPipTalkback),'iconfont icon-micOn':!(hasTalkback||hasHostTalkback||hasPipTalkback)}">
                </i>
                <i  v-else style="font-size:28px;border:0;"  :style="{'color':(hasTalkback||hasHostTalkback||hasPipTalkback) ?'#6D6D6D':'#F6445A'}" class="iconfont icon-a-mic" >
                </i>
              </span>
              <span style="top: -10px;display: block;" :style="{'color':(hasTalkback||hasHostTalkback||hasPipTalkback) ?'#6D6D6D':''}">{{$t('coordinationParticipant.mic')}}</span>
            </i>
          </el-tooltip>
          <device-select
            v-if="
              devicesInfo.microphoneList &&
                devicesInfo.microphoneList.length &&
                rtcLoaded
            "
            :class="{ m_r_40: !State.showFeedbackBtn }"
            title="Select a Microphone"
            @changeDevice="changeDevice"
            @updateDeviceId="updateDeviceId"
            :audioInfo="audioInfo"
            type="audio"
            :deviceSelectId="devicesInfo.microphoneId"
            :data="devicesInfo.microphoneList"
          />
          <!-- audio feedback 区域 -->
          <el-divider class="feedbackDivider" direction="vertical" v-if="State.showFeedbackBtn"></el-divider>
          <el-tooltip :content="State.enableFeedback ? $t('audioSettings.turnOffFeedback') : $t('audioSettings.turnOnFeedback')">>
            <span v-if="State.showFeedbackBtn" class="feedbackBox m_r_40">
              <i
                class="iconfont pointer"
                :class="audioFeedbackClass"
                @click="controlFeedback()"
              ></i>
              <span class="f_12 btnText" style="width:100%;">{{ $t('audioSettings.audioFeedback') }}</span>
            </span>
          </el-tooltip>
          <!-- Talkback 区域 -->
          <el-tooltip
            class="talkAll relative"
            effect="dark"
            :content="this.$t('coordinationParticipant.clikAndHold')"
            placement="top"
          >
            <span>
              <i
                v-if="!talkbackLoading"
                class="iconfont pointer"
                :class="talkbackClass"
                @pointerup="onPointerUp('callAll', 'i up')"
                @pointerdown="onPointerDown($event, 'callAll')"
              ></i>
              <span v-else class="loading" @mouseout="leaveCallAllIcon = true" @pointerdown="onPointerDown($event, 'callAll')" @pointerup="onPointerUp('callAll', 'loading up')">
                <svg class="iconfont" aria-hidden="true">
                  <use xlink:href="#icon-a-BTNloading"></use>
                </svg>
              </span>
              <div v-if="hasTalkback && !talkbackLoading" class="talkAnimation" style="margin-top:-8px;"></div>
              <div v-if="hasTalkback && !talkbackLoading" class="talkAnimation" style="margin-top:-8px;"></div>
              <span class="f_12 btnText">{{ $t('coordinationParticipant.talkBack') }}</span>
            </span>
          </el-tooltip>
          <!--TalkBack host-->
          <el-tooltip
            class="talkHost relative"
            effect="dark"
            :content="this.$t('coordinationParticipant.clikAndHostHold')"
            placement="top"
          >
            <span>
              <i
                v-if="!talkbackRoomLoading"
                class="iconfont pointer"
                :class="talkbackRoomClass"
                @pointerup="onPointerUp('callHost', 'i host up')"
                @pointerdown="onPointerDown($event, 'callHost')"
              ></i>
              <span v-else class="loading" @mouseout="leaveCallRoomIcon = true" @pointerdown="onPointerDown($event, 'callHost')" @pointerup="onPointerUp('callHost', 'i loading up')">
                <svg class="iconfont" aria-hidden="true">
                  <use xlink:href="#icon-a-BTNloading"></use>
                </svg>
              </span>
              <div v-if="hasHostTalkback && !talkbackRoomLoading" class="talkAnimation" style="margin-top:-8px;"></div>
              <div v-if="hasHostTalkback && !talkbackRoomLoading" class="talkAnimation" style="margin-top:-8px;"></div>
              <span class="f_12 btnText">{{ $t('coordinationParticipant.talkHostBack') }}</span>
            </span>
          </el-tooltip>
           <!--TalkBack pip-->
          <el-tooltip
            class="talkPip relative"
            effect="dark"
            :content=" this.$t('coordinationParticipant.clikAndPipHold')"
            placement="top"
          >
          <span>
            <i
              v-if="!talkbackGroupLoading"
              class="iconfont pointer"
              :class="talkbackGroupClass"
              @pointerup="onPointerUp('callPip', 'i pip up')"
              @pointerdown="onPointerDown($event, 'callPip')"
            ></i>
            <span v-else class="loading" @mouseout="leaveCallGroupIcon = true" @pointerdown="onPointerDown($event, 'callPip')" @pointerup="onPointerUp('callPip', 'loading pip up')">
              <svg class="iconfont" aria-hidden="true">
                <use xlink:href="#icon-a-BTNloading"></use>
              </svg>
            </span>
            <div v-if="hasPipTalkback && !talkbackGroupLoading" class="talkAnimation" style="margin-top:-8px;"></div>
            <div v-if="hasPipTalkback && !talkbackGroupLoading" class="talkAnimation" style="margin-top:-8px;"></div>
            <span class="f_12 btnText">{{ $t('coordinationParticipant.talkPipBack') }}</span>
          </span>
          </el-tooltip>
        </div>
        <TipsDailog :info="leaveTips" @save="leaveParty"/>
        <!-- 重复登入 -->
        <tipsDailog class="repeatJoin" width="550px" :info="repeatInfo" @save="repeatInfo.show = false">
          <div class="email">
            <p>{{ $t('coordinationRoom.repeatContent') }}</p>
          </div>
        </tipsDailog>
        <tipsDailog class="micMuted" :info="showMicMutedInfo"  width="560px">
          <div class="micMutedContent">
            <div class="title">{{ $t('micMutedInfo.contentTitle') }}</div>
            <div class="message">{{ $t('micMutedInfo.contentMessage') }}</div>
            <span class="openMicBtn" @click="openMicMuted">{{ $t('micMutedInfo.openBtnMes') }}</span>
          </div>
        </tipsDailog>
        <MutedPop
          ref="muted"
          v-if="speakInfo.speaking"
          :info="speakInfo"
          @reusePop="closeMute()"
         />
        <user-setting
          @setNickName="setNickName"
          v-if="setNameInfo.show"
          :info="setNameInfo"
        ></user-setting>
      </div>
    </div>
    <participant-setting :info="participantSettingInfo" :audioInfo="audioInfo"
    ></participant-setting>
  </div>
</template>
<script>
import Group from './group'
import Bus from '@/assets/js/bus.js'
import { mapState } from 'vuex'
import Utils, { updateAmSourceName } from '@/assets/js/utils.js'
import AgoraClient from '@/assets/js/rtc-client-ng'
import AttendUser from '@/components/common/attendUser'
import { audioContextObj } from '@/assets/js/audioContext'
import TipsDailog from '@/components/common/tipsDailog'
import MutedPop from '@/views/commentator/dialog/mutedPop'
import DeviceSelect from '@/components/common/deviceSelect'
import Websocket from '@/assets/js/websocket.js'
import UserSetting from '@/components/common/userSetting'
import { getMicAndSpeakerDevices } from '@/assets/js/agoraFeature.js'
import axios from 'axios'
import VolumeBar from '@/assets/js/volumeBar.js'
import ParticipantSetting from '@/views/commentator/dialog/participantSetting'

const CancelToken = axios.CancelToken

export default {
  data () {
    return {
      showOffSetBtn: false,
      timestampOffset: 0, // 时间戳偏移值
      audioInfo: {},
      audioQualityPreset: '',
      checkedAec: true,
      checkedAns: true,
      checkedAgc: true,
      osLevelmicMuted: false,
      showMicMutedInfo: {
        show: false,
        title: 'micMutedInfo.title',
        hideSave: true,
        hideCancel: true,
        showGotIt: true,
        gotIt: 'micMutedInfo.ignore'
      },
      websockets: [],
      amWsversion: '',
      initJoin: true,
      encodedData: '',
      realtimeApiHostname: '',
      amStatusInfo: {},
      allPairStatusInfo: {},
      pairNumber: 0,
      isSpeaking: false,
      speakTimer: null,
      silenceTimer: null,
      manualShutdown: false,
      speakInfo: {
        speaking: false
      },
      initVideoPopup: true,
      initAudioPopup: true,
      lastDisableCamera: 0,
      lastDisableMic: 0,
      isCommentatorParty: '',
      switchVal: '',
      seiSwitch: false,
      remoteNetWorks: {},
      audioStatus: '',
      talkBackType: '',
      noCallBackRtilCode: '',
      privateInfo: {},
      hadOpenWebCloud: false,
      rtc: {},
      meInfo: {},
      userInfo: {},
      rtilCode: '',
      voiceList: {},
      channels: {},
      externalChannel: {},
      devicesInfo: {},
      nickNameInfo: {},
      audioSettingInfo: {},
      videoObj: {},
      muteAudioObj: {},
      realPartyCode: '',
      externalPartyCode: '',
      videoSelf: true,
      muteAudioSelf: false,
      leaveTips: {
        title: 'coordinationParticipant.leavePartyTitle',
        content: 'Are you sure to leave the party?',
        cancel: 'coordinationParticipant.cancel',
        save: 'coordinationParticipant.leave',
        show: false
      },
      repeatInfo: {
        show: false,
        title: 'coordinationRoom.repeatJoin',
        save: 'coordinationRoom.ok',
        hideCancel: true
      },
      rtcLoaded: false,
      hangupHover: false,
      carmerHover: false,
      hadPushTalk: true,
      hasTalkback: false,
      hasHostTalkback: false,
      hasPipTalkback: false,
      outputRtilCode: '',
      hostInfo: {},
      initMuteVideo: true,
      networkTips: false,
      isPrivate: false,
      maxTimeDifference: 0,
      setNameInfo: {
        show: false
      },
      cancel: {
        removeMixAudio: null,
        addMixAudio: null,
        addTalkback: null,
        removeTalkback: null
      },
      metaDataTimeCode: '',
      metaDateTimeStamp: '',
      groupInfo: {},
      hostPrivateInfo: {}, // 用来记录哪些 host 和当前与会者有 pusktalk
      talkToGroupList: [], // 用来维护当前哪些 host 开启 talk to group
      talkToAllGroupList: [], // 用来维护当前哪些 host 开启 talk to all group
      pgmMute: false,
      password: '',
      seiInfo: null,
      hasTalkToAllGroupInfo: {},
      talkbackLoading: false,
      talkbackRoomLoading: false,
      talkbackGroupLoading: false,
      sendTalkbackTimer: null,
      isLongPress: false,
      haskeyDown: false, // 用来防止快捷键长按时会一直执行函数的问题
      leaveCallAllIcon: false,
      leaveCallRoomIcon: false,
      leaveCallGroupIcon: false,
      dealySendTalkTimer: null,
      participantSettingInfo: {
        show: false
      }
    }
  },
  components: {
    Group,
    TipsDailog,
    DeviceSelect,
    UserSetting,
    AttendUser,
    MutedPop,
    ParticipantSetting
  },
  computed: {
    ...mapState({
      State: (state) => state,
      isMute: (state) => state.isMute,
      // isReplyAudio: (state) => state.isReplyAudio,
      Config: (state) => state.config,
      eventInfo: state => state.eventInfo,
      socket: (state) => state.socket
    }),
    speakerTitle () {
      let _str = this.$t('coordinationParticipant.turnOffSpeaker')
      if (this.isMute) {
        _str = this.$t('coordinationParticipant.turnOnSpeaker')
      }
      return _str
    },
    micTitle () {
      let _str = this.$t('coordinationParticipant.turnOffMicPhone')
      if (!this.hadPushTalk) {
        _str = this.$t('coordinationParticipant.turnOnMicPhone')
      }
      return _str
    },
    audioFeedbackClass () {
      return this.State.enableFeedback ? 'icon-a-hearself-on greenBg' : 'icon-a-hearself-off active'
    },
    talkbackClass () {
      return this.hasTalkback ? 'icon-a-TalkbackAll lightGreenColor' : 'icon-talkBackAll lightRedColor'
    },
    talkbackRoomClass () {
      return this.hasHostTalkback ? 'icon-talkHostOff lightGreenColor' : 'iconfont icon-talkBackCoord lightRedColor'
    },
    talkbackGroupClass () {
      return this.hasPipTalkback ? 'icon-talkPipOff lightGreenColor' : 'icon-talkBackGroup lightRedColor'
    }
  },
  watch: {
    hadPushTalk (newVal) {
      if (newVal) {
        this.speakInfo.speaking = false
        this.manualShutdown = false
        this.clearTimer()
      }
    },
    hasTalkback (newVal) {
      if (newVal) {
        // 当有talkback时,将开启的弹窗关闭
        this.speakInfo.speaking = false
        // 为了重置手动关闭的状态
        this.manualShutdown = false
        this.clearTimer()
      }
    },
    hasHostTalkback (newVal) {
      if (newVal) {
        this.speakInfo.speaking = false
        this.manualShutdown = false
        this.clearTimer()
      }
    },
    hasPipTalkback (newVal) {
      if (newVal) {
        this.speakInfo.speaking = false
        this.manualShutdown = false
        this.clearTimer()
      }
    },
    'State.showFeedbackBtn': {
      handler (newVal) {
        if (!newVal) {
          this.State.showFeedbackBtn = false
          localStorage.setItem('enabledFeedback', false)
          if (this.State.enableFeedback && this.rtc?.[this.realPartyCode]?._localAudioTrack) {
            this.State.enableFeedback = false
            this.rtc[this.realPartyCode]._localAudioTrack.stop()
          }
        }
      }
    }
  },
  async created () {
    const settings = localStorage.getItem('timestampOffsetSettings')
    if (settings) {
      const { offset } = JSON.parse(settings)
      this.timestampOffset = offset || 0
    }
    this.State.showFeedbackBtn = localStorage.getItem('showFeedbackBtn') === 'true'
    this.State.enableFeedback = localStorage.getItem('enabledFeedback') === 'true'
    // 初始化是否使用SEI发送时间戳（先禁用sei）
    // this.seiSwitch = localStorage.getItem('seiSwitch') === 'true'
    const contentBoxes = document.getElementsByClassName('contentBox')
    if (contentBoxes && contentBoxes.length > 0 && contentBoxes[0].style) {
      contentBoxes[0].style.height = 'calc(100vh - 65px)'
    }
    navigator.mediaDevices.addEventListener('devicechange', async (info) => {
      if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
        this.$message({
          type: 'warning',
          message: this.$t('coordinationParticipant.notSupportSwitchSpeaker')
        })
        return
      }
      // 设备发生变化时执行的操作
      for (const k in this.rtc) {
        const rtc = this.rtc[k]
        const { microphoneId, microphoneArray, speakerId, speakerArray } = await getMicAndSpeakerDevices(rtc)
        // 只有在设备列表没有变化只是更新 default 设备时执行
        if (microphoneArray &&
        this.devicesInfo &&
        this.devicesInfo.microphoneList &&
         microphoneArray?.length == this.devicesInfo.microphoneList?.length &&
         microphoneArray?.length > 0) {
          if (microphoneId) {
            this.devicesInfo.microphoneId = microphoneId
            rtc.setDevice(microphoneId, 'audio')
            this.detecteMicMuted()
          }
          this.devicesInfo.microphoneList = microphoneArray
        }
        // 只有在设备列表没有变化只是更新 default 设备时执行
        if (speakerArray &&
        this.devicesInfo &&
        this.devicesInfo.speakerList &&
        speakerArray.length == this.devicesInfo.speakerList.length &&
         speakerArray.length > 0) {
          if (speakerId) {
            this.devicesInfo.speakerId = speakerId
            const array = Object.keys(this.channels).filter(rtilCode => {
              return rtilCode != this.userInfo.rtilCode
            })
            array.forEach(rtilCode => {
              if (this.channels[rtilCode].audioTrack && this.channels[rtilCode].audioTrack.setPlaybackDevice) {
                this.channels[rtilCode].audioTrack.setPlaybackDevice(localStorage.getItem('speakerId')).catch(() => {})
              }
            })
          }
          this.devicesInfo.speakerList = speakerArray
        }
      }
    })
    Bus.$on('openAudioSetting', () => {
      this.participantSettingInfo.show = true
      this.participantSettingInfo.userInfo = {
        partyCode: this.State.userInfo.realPartyCode,
        rtilCode: this.State.userInfo.rtilCode,
        eventInfo: this.State.eventInfo
      }
    })
    Bus.$on('pgmChange', (val) => {
      const arr = val.newPgmSlot.sharedMemoryName.split('_');
      if (val.newPgmSlot && val.newPgmSlot.pips) {
        const pips = val.newPgmSlot.pips
        if (pips.some(item => item.includes('Commentator'))) {
          this.isCommentatorParty = true
        } else {
          this.isCommentatorParty = false
        }
      } else {
        this.isCommentatorParty = false
      }
      if ((arr[0] == 'Commentator' && arr[1] == this.realPartyCode && arr[2] == this.userInfo.rtilCode) ||
      (val.newPgmSlot && val.newPgmSlot.tType == 3 && val.newPgmSlot.sourceType == 600 &&
      this.isCommentatorParty)) {
        this.switchVal = true
      } else {
        this.switchVal = false
      }
    })
    Bus.$off('setLoginScreenButton');
    // 新增cloudProxy
    Bus.$on('setLoginScreenButton', async (val) => {
      const { buttonType, operationType } = val.buttonStatus;
      if (buttonType === 7) {
        if (operationType) {
          this.hadOpenWebCloud = true
          for (const k in this.rtc) {
            this.rtc[k] && await this.rtc[k].leave()
          }
          this.joinParty()
        } else {
          this.hadOpenWebCloud = false
          for (const k in this.rtc) {
            this.rtc[k] && await this.rtc[k].leave('closeCLoudProxy')
          }
          this.joinParty()
        }
      } else if (buttonType === 11) {
        if (!operationType) {
          if (this.$route.name !== 'remove') {
            this.$router.push({ name: 'remove', query: { type: 'disableParty' } })
          }
        }
      }
    })
    const { id } = this.$route.query
    const { password } = this.$route.params
    this.partyCode = id
    // 过滤掉非数字字符
    if (this.partyCode) this.partyCode = this.partyCode.replace(/[^0-9]/gi, '')
    // 检查各种长度的重复情况
    this.partyCode = this.partyCode.length === 24 ? Utils.removeDuplicateSegments(this.partyCode, this.partyCode.length) : this.partyCode
    if (this.partyCode.length != 12) {
      this.$message.error(this.$t('leaveParty.invalidPartyIdText'))
      return
    }
    this.password = password
    this.rtc[this.partyCode] = new AgoraClient(this.callBack)
    if (!localStorage.getItem(`nickName_${this.partyCode}`) || !localStorage.getItem(`speaker_${this.partyCode}`) || !localStorage.getItem(`camera_${this.partyCode}`) ||
  !localStorage.getItem(`mic_${this.partyCode}`)) {
      this.$router.push({
        name: 'preview',
        query: {
          id: this.partyCode
        }
      }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          console.error('导航失败:', error)
        }
      })
      return
    }
    // 需要先获取设备列表，并判断之前选择过的设备列表是否还存在，不存在则选择默认的
    this.devicesInfo = this.rtc[this.partyCode] && await this.rtc[this.partyCode].getDevice()
    if (!localStorage.getItem('speakerId')) {
      localStorage.setItem('speakerId', this.devicesInfo.speakerId)
    }
    this.setNameInfo.cameraId = this.devicesInfo.cameraId
    this.setNameInfo.microphoneId = this.devicesInfo.microphoneId
    await this.setNameOrJoin()
    await this.getCurrentEventInfo()
    await this.getGroupInfo()
    Bus.$on('controlSendSei', val => {
      this.seiSwitch = val
      localStorage.setItem('seiSwitch', val)
      if (val) {
        this.$message.success('Timestamp successfully sent via SEI.')
      } else {
        this.$message.success('Timestamp successfully sent via Date Channel.')
      }
    })
    Bus.$on('addPipSuccess', (result) => {
      if (this.initJoin) {
        this.getPairList(result.audioMixTaskId, result.eventId)
      }
    })
    Bus.$on('setOutput', (info) => {
      const { rtilCode } = info
      this.outputRtilCode = rtilCode
      if (this.rtc[this.externalPartyCode] && this.rtc[this.externalPartyCode]._remotePublishUser[this.outputRtilCode]) {
        this.rtc[this.externalPartyCode].subscribe(rtilCode, 'all')
      }
    })
    Bus.$on('coordination', info => {
      const { enable, type, subPartyCode, rtilCode, starterRtilCode } = info
      if ((type === 'group' || type === 'room') && this.eventInfo) {
        this.$http
          .post(`${this.State.config.urlInfo.partyline}/partyline-backend/coordination/noLogin/group/${this.eventInfo.id}`)
          .then(res => {
            if (res.data.errorCode === '0x0') {
              const { result } = res.data
              result.newGroupSettings && result.newGroupSettings.forEach(item => {
                this.$set(this.groupInfo, item.partyCode, item)
              })
            }
          })
        if (enable) {
          // 先订阅
          this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].subscribe(starterRtilCode, 'audio')
          // 判断当前的speaker是否处于静音状态
          if (!this.isMute && this.rtc[this.realPartyCode]._subscribeTrack[starterRtilCode] && this.rtc[this.realPartyCode]._subscribeTrack[starterRtilCode].audioTrack) {
            this.rtc[this.realPartyCode].play(this.rtc[this.realPartyCode]._subscribeTrack[starterRtilCode].audioTrack, '', { type: 'audio' })
          }
          if (this.muteAudioSelf) {
            this.changeBehaviorStatus('mic', true)
          }
        } else {
          // 有 subPartyCode 表示部分，没有则表示取消全部 talk group
          if (!subPartyCode && this.rtc[this.realPartyCode]._subscribeTrack[starterRtilCode]) {
            this.rtc[this.realPartyCode].stop(this.rtc[this.realPartyCode]._subscribeTrack[starterRtilCode].audioTrack)
            this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].unsubscribe(starterRtilCode, 'audio')
          } else if (subPartyCode == this.realPartyCode && this.rtc[this.realPartyCode]._subscribeTrack[starterRtilCode]) {
            this.rtc[this.realPartyCode].stop(this.rtc[this.realPartyCode]._subscribeTrack[starterRtilCode].audioTrack)
            this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].unsubscribe(starterRtilCode, 'audio')
          }
        }
      } else if (type === 'member') {
        if (subPartyCode == this.userInfo.realPartyCode && rtilCode == this.userInfo.rtilCode) {
          this.$set(this.hostPrivateInfo, starterRtilCode, enable == 1)
          const rtc = this.rtc[this.realPartyCode]
          if (enable) {
            // 如果 Agora 退消息快于 ws，则我们需要在这重新订阅一次
            if (rtc._remotePublishUser[starterRtilCode] &&
              (!rtc._subscribeTrack[starterRtilCode] || !rtc._subscribeTrack[starterRtilCode].audioTrack)
            ) {
              rtc && rtc.subscribe(starterRtilCode, 'audio')
            }
          } else {
            if (rtc._subscribeTrack[starterRtilCode]) {
              rtc && rtc.unsubscribe(starterRtilCode, 'audio')
            }
          }
        }
        this.controlPrivateInfo(rtilCode, enable, starterRtilCode)
      }
    })
    Bus.$on('setBehaviors', (v) => {
      const behaviors = v.behaviors
      behaviors.forEach((val) => {
        if (val.key == 'audioStatus') {
          this.audioStatus = val.value
        }
        if (val.key == 'nickName') {
          this.$set(this.nickNameInfo, val.mark, val.value)
        }
        if (val.key == 'tagName') {
          this.$set(this.tagNameInfo, val.mark, val.value)
        }
        if (val.key == 'audioSettings') {
          this.$set(this.audioSettingInfo, val.mark, JSON.parse(val.value))
          this.getAudioSetting()
        }
        // talkBack
        if (val.key == 'callAll') {
          this.talkBackType = 'callAll'
          if (val.value == 'true') {
            this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].subscribe(val.mark, 'audio')
          }
        } else if (val.key == 'callHost') {
          this.talkBackType = 'callHost'
          // callHost不订阅同组其他人audio
          if (val.value == 'true' && val.mark != this.userInfo.rtilCode) {
            this.noCallBackRtilCode = val.mark
            if ((this.audioStatus && JSON.parse(this.audioStatus)) || (this.channels[val.mark] && this.channels[val.mark].audioTrack)) {
              this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].unsubscribe(val.mark, 'audio')
            }
          } else {
            this.talkBackType = ''
            if (this.audioStatus && JSON.parse(this.audioStatus)) {
              this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].subscribe(val.mark, 'audio')
            }
          }
        }
        if (val.key == 'camera' && val.initiator && val.mark == this.rtilCode && this.rtc[this.realPartyCode]?._localVideoTrack) {
          if (this.rtc[this.realPartyCode]?._localVideoTrack && this.rtc[this.realPartyCode]._localVideoTrack._originMediaStreamTrack) {
            this.rtc[this.realPartyCode]._localVideoTrack._originMediaStreamTrack.enabled = !(val.value === 'true')
          }
          this.videoSelf = (val.value === 'true')
        }
        if (val.key == 'talkToAllGroup') {
          this.dealTalkToAllGroup(val)
        }
        if (val.key === 'talkToGroup') {
          this.dealTalkToGroup(val)
        }
      })
    })
    Bus.$on('controlBehavior', v => {
      const { rtilCode, behavior } = v
      const { key, value } = behavior
      if (key == 'nickName' && this.nickNameInfo[rtilCode]) {
        this.nickNameInfo[rtilCode] = value
      }
    })
    Bus.$on('managerOnline', v => {
      const { rtilCode } = v
      if (this.userInfo.managerRtils && !this.userInfo.managerRtils.includes(rtilCode)) this.userInfo.managerRtils.push(rtilCode)
      // 把后进来的 host 添加到 hostprivate 数组中方便控制是否订阅次 host 的音频流
      if (!this.hostPrivateInfo[rtilCode]) {
        // 还需要判断当前的 talk to group 是否开启如果开启
        this.$set(this.hostPrivateInfo, rtilCode, false)
        // 由于存在和 ws 消息和 Agora 推送人进来的先后快慢问题所以这里边也要添加订阅逻辑
        if (
          this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode]._remotePublishUser[rtilCode] &&
          (!this.rtc[this.realPartyCode]._subscribeTrack[rtilCode] || !this.rtc[this.realPartyCode]._subscribeTrack[rtilCode].audioTrack)
        ) {
          this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].subscribe(rtilCode, 'audio')
        }
      }
    })
    window.addEventListener('keydown', this.keyDownEvent)
    window.addEventListener('keyup', this.keyupEvent)
    window.addEventListener('pointerup', () => {
      if (this.hasTalkback || this.leaveCallAllIcon) this.onPointerUp('callAll', 'listen up')
      if (this.hasHostTalkback || this.leaveCallRoomIcon) this.onPointerUp('callHost', 'listen up')
      if (this.hasPipTalkback || this.leaveCallGroupIcon) this.onPointerUp('callPip', 'listen up')
    })
    Bus.$on('endParty', v => {
      this.$router.push({ name: 'leaveParty' }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          console.error('导航失败:', error)
        }
      })
    })
    // 移出party
    Bus.$off('removeParticipant')
    Bus.$on('removeParticipant', v => {
      if (v.rtilCode === this.rtilCode) {
        this.rtc[this.realPartyCode].leave()
        if (this.$route.name !== 'remove') {
          this.$router.push({ name: 'remove', query: { type: 'leavrParty' } })
        }
      }
    })
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar()
    }
  },
  methods: {
    controlFeedback () {
      this.State.enableFeedback = !this.State.enableFeedback
      localStorage.setItem('enabledFeedback', this.State.enableFeedback)
    },
    adjustTimestamp (ms) {
      this.timestampOffset += ms
      this.$message.success(`adjusted ${ms > 0 ? '+' : ''}${ms}ms`)
      localStorage.setItem('timestampOffsetSettings', JSON.stringify({
        offset: this.timestampOffset
      }))
    },
    canvasDrap (id, data) {
      const canvas = document.getElementsByClassName(id)
      if (!canvas || canvas.length == 0) return
      if (canvas && canvas.length > 0) {
        for (let i = 0; i < canvas.length; i++) {
          const currentCanvas = canvas[i]
          const w = currentCanvas.clientWidth
          const h = currentCanvas.clientHeight
          const currentPercent = data
          const ctx = currentCanvas.getContext('2d')
          currentCanvas.width = w
          currentCanvas.height = h
          currentCanvas.style.transform = 'rotate(180deg)'
          // 填充渐变色, fillRect 是从左上角开始 即(0,0)坐标开始.
          // 因此注意,canvas显示的时候旋转 canvas 180度 是个好的解决方案
          const gradient = ctx.createLinearGradient(0, 0, 0, h)
          gradient.addColorStop(0, '#5DC045')
          gradient.addColorStop(0.29, '#5DC045')
          gradient.addColorStop(0.8, '#F1D737')
          gradient.addColorStop(1, '#F6445A')
          ctx.clearRect(0, 0, w, h)
          ctx.fillStyle = gradient
          ctx.fillRect(0, 0, w, currentPercent * h)
        }
      }
    },
    // 应用设置项的值
    // 新增方法：生成存储键名
    generateStorageKey () {
      const { realPartyCode: partyCode } = this.State.userInfo || {}
      const eventId = this.eventInfo?.id
      return `audioSettings_${partyCode}_${eventId}`
    },
    applySetting (storedSettings, userSettingItem, settingKey) {
      const storedValue = storedSettings?.settings?.[settingKey]// pip 时间戳 和 value
      const userUpdateTime = userSettingItem?.updateTime || 0 // host 时间戳
      if (storedValue) {
        // 时间戳比较逻辑
        if (storedValue?.timestamp && storedValue.timestamp > userUpdateTime) {
          this[settingKey] = storedValue.value
        } else if (userSettingItem) {
          this[settingKey] = userSettingItem.value === 'true'
        }
      } else {
        this[settingKey] = userSettingItem.value === 'true'
      }
    },
    async setPreviewAudioSetting () {
      // 生成动态存储键
      const storageKey = this.generateStorageKey()
      // debugger
      const localData = localStorage.getItem(storageKey)
      if (!localData) return
      const params = [
        {
          mark: this.State.userInfo.rtilCode + '',
          annotation: this.partyCode,
          key: 'audioSettings',
          value: localData,
          notify: true
        }
      ]
      this.$http.post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/setList`, params)
        .then((res) => {
          if (res.data.errorCode === '0x0') {
            localStorage.removeItem(storageKey)
          }
        })
    },
    async getAudioSetting () {
      try {
        const storedData = this.audioSettingInfo?.[this.rtilCode]
        // 获取用户设置
        const userSettings = this.eventInfo?.userSettings || []
        // 处理每个设置项
        userSettings && userSettings.forEach(item => {
          switch (item.name) {
            case 'audioAec':
              this.checkedAec = item.value === 'true'
              this.applySetting(storedData, item, 'checkedAec', item)
              break
            case 'audioAns':
              this.checkedAns = item.value === 'true'
              this.applySetting(storedData, item, 'checkedAns', item)
              break
            case 'audioAgc':
              this.checkedAgc = item.value === 'true'
              this.applySetting(storedData, item, 'checkedAgc', item)
              break
          }
        })
        this.audioQualityPreset = storedData?.audioQualityPreset
        // 最终的值
        this.audioInfo = {
          checkedAec: this.checkedAec,
          checkedAns: this.checkedAns,
          checkedAgc: this.checkedAgc,
          audioQualityPreset: this.audioQualityPreset
        }
      } catch (error) {
        console.error('加载音频设置失败:', error)
      }
    },
    detecteMicMuted () {
      try {
        const mediaStream = this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode]._localAudioTrack && this.rtc[this.realPartyCode]._localAudioTrack._mediaStreamTrack
        if (!mediaStream) return
        this.osLevelmicMuted = mediaStream?.muted
        mediaStream.onmute = () => {
          this.osLevelmicMuted = true
        }
        mediaStream.onunmute = () => {
          this.osLevelmicMuted = false
        }
      } catch (error) {
        console.error('检测麦克风状态失败:', error)
      }
    },
    openMicMuted () {
      window.open('ms-settings:sound', '_blank')
    },
    keyDownEvent (e) {
      if (!this.rtcLoaded) return
      const keyCodes = e.keyCode || e.which
      if (keyCodes === 32 && !this.hasKeyDown) {
        this.hasKeyDown = true
        this.onPointerDown(e, 'callAll')
      } else if (keyCodes === 67 && !this.hasKeyDown) {
        this.hasKeyDown = true
        this.onPointerDown(e, 'callHost')
      } else if (keyCodes === 71 && !this.hasKeyDown) {
        this.hasKeyDown = true
        this.onPointerDown(e, 'callPip')
      }
    },
    keyupEvent (e) {
      if (!this.rtcLoaded) return
      const keyCodes = e.keyCode || e.which
      if (keyCodes === 32) {
        this.onPointerUp('callAll')
      } else if (keyCodes === 67) {
        this.onPointerUp('callHost')
      } else if (keyCodes === 71) {
        this.onPointerUp('callPip')
      } else if (keyCodes === 77) {
        // 新增快捷键控制 mic
        this.setOperate({ type: 'muteAudio', id: this.userInfo.rtilCode })
      }
    },
    clearTimer () {
      // 清除所有计时器
      this.isSpeaking = false;
      clearTimeout(this.speakTimer);
      clearTimeout(this.silenceTimer);
      this.speakTimer = null;
      this.silenceTimer = null;
    },
    closeMute () {
      this.speakInfo.speaking = false
      this.manualShutdown = true
      this.clearTimer()
    },
    dealTalkToAllGroup (behaviors) {
      const { mark, value } = behaviors
      this.$set(this.hostPrivateInfo, mark, value == '1')
      if (value == '1') {
        if (this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode]._remotePublishUser[mark]) {
          this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].subscribe(mark, 'audio')
        }
        this.controlPrivateInfo('', 1, mark)
        if (!this.talkToAllGroupList.includes(mark)) {
          this.talkToAllGroupList.push(mark)
        }
      } else {
        this.controlPrivateInfo('', 0, mark)
        if (this.talkToAllGroupList.includes(mark)) {
          this.talkToAllGroupList = this.talkToAllGroupList && this.talkToAllGroupList.filter(rtilCode => {
            return rtilCode != mark
          })
        }
      }
    },
    dealTalkToGroup (behaviors) {
      const { mark, value } = behaviors
      this.$set(this.hostPrivateInfo, mark, value == '1')
      this.controlPrivateInfo('', value, mark)
      // 如果 val == 1 需要考虑 ws 消息和 Agora 谁想返回的问题，所以在这里加一步订阅当前 host 音频流
      if (value == '1') {
        if (
          this.rtc[this.realPartyCode] &&
          this.rtc[this.realPartyCode]._remotePublishUser[mark] &&
          (!this.rtc[this.realPartyCode]._subscribeTrack[mark] || !this.rtc[this.realPartyCode]._subscribeTrack[mark].audioTrack)
        ) {
          this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].subscribe(mark, 'audio')
        }
        if (!this.talkToGroupList.includes(mark)) {
          this.talkToGroupList.push(mark)
        }
      } else {
        this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].unsubscribe(mark, 'audio')
        if (this.talkToGroupList.includes(mark)) {
          this.talkToGroupList = this.talkToGroupList && this.talkToGroupList.filter(rtilCode => {
            return rtilCode != mark
          })
        }
      }
    },
    // 维护 pusktalk 状态 privateInfo 的方法
    controlPrivateInfo (rtilCode, value, starterRtilCode) {
      if (rtilCode) {
        // 先判断之前是否记录过此数据，没有则添加
        if (!this.privateInfo[rtilCode]) {
          this.$set(this.privateInfo, rtilCode, [starterRtilCode])
        } else {
          // 如果当前有值在根据推送的 enable 来进行处理，因为是多 host 所以才把 private 的 value 改成数组
          if (value == 1) {
            if (!this.privateInfo[rtilCode].includes(starterRtilCode)) {
              this.privateInfo[rtilCode].push(starterRtilCode)
              this.$set(this.privateInfo, rtilCode, this.privateInfo[rtilCode])
            }
          } else {
            const array = this.privateInfo[rtilCode] && this.privateInfo[rtilCode].filter(rtilCode => {
              return rtilCode != starterRtilCode
            })
            this.$set(this.privateInfo, rtilCode, array)
          }
        }
      } else {
        if (value == 1) {
          // 维护与会者自己的 pushtalk 状态
          if (!this.privateInfo[this.userInfo.rtilCode]) {
            this.$set(this.privateInfo, this.userInfo.rtilCode, [starterRtilCode])
          } else {
            if (!this.privateInfo[this.userInfo.rtilCode].includes(starterRtilCode)) {
              this.privateInfo[this.userInfo.rtilCode].push(starterRtilCode)
              this.$set(this.privateInfo, this.userInfo.rtilCode, this.privateInfo[this.userInfo.rtilCode])
            }
          }
          // 维护当前组内其他与会者的 pushtalk状态
          Object.keys(this.channels).forEach(rtilCode => {
            if (!this.privateInfo[rtilCode]) {
              this.$set(this.privateInfo, rtilCode, [starterRtilCode])
            } else {
              if (!this.privateInfo[rtilCode].includes(starterRtilCode)) {
                this.privateInfo[rtilCode].push(starterRtilCode)
                this.$set(this.privateInfo, rtilCode, this.privateInfo[rtilCode])
              }
            }
          })
        } else {
          const hostArray = this.privateInfo[this.userInfo.rtilCode] && this.privateInfo[this.userInfo.rtilCode].filter(rtilCode => {
            return rtilCode != starterRtilCode
          })
          this.$set(this.privateInfo, this.userInfo.rtilCode, hostArray)
          Object.keys(this.channels).forEach(rtilCode => {
            const otherParticipants = this.privateInfo[rtilCode] && this.privateInfo[rtilCode].filter(currentRtilCode => {
              return currentRtilCode != starterRtilCode
            })
            this.$set(this.privateInfo, rtilCode, otherParticipants)
          })
        }
      }
    },
    // 记录pp事件是否为pgm上mainWindow的状态
    eventState () {
      if (!this.eventInfo) {
        return
      }
      this.$http
        .get(`/commentator-backend/event/v2/noLogin/state/${this.eventInfo.id}`)
        .then(res => {
          if (res.data.errorCode === '0x0') {
            const { result } = res.data
            if (result && result.source) {
              const arr = result.source.pgm.shareMemoryName.split('_')
              if (result.source.slots[result.source.pgm.slot] && result.source.slots[result.source.pgm.slot].pips) {
                const pips = result.source.slots[result.source.pgm.slot].pips
                if (pips.some(item => item?.includes?.('Commentator'))) {
                  this.isCommentatorParty = true
                } else {
                  this.isCommentatorParty = false
                }
              } else {
                this.isCommentatorParty = false
              }
              // 判断是否为将participant as PGM 或者 participant as customer source
              if ((arr[0] == 'Commentator' && arr[1] == this.realPartyCode && arr[2] == this.userInfo.rtilCode) ||
            (result.source.slots[result.source.pgm.slot] && result.source.slots[result.source.pgm.slot].tType == 3 && result.source.slots[result.source.pgm.slot].sourceType == 600 &&
            this.isCommentatorParty)) {
                this.switchVal = true
              } else {
                this.switchVal = false
              }
            }
          }
        })
    },
    groupCallback ({ type, val, isControlMute }) {
      if (type === 'fullscreen') {
        this.State.fullScreen = val
        if (val && document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
        } else {
          if (document.fullscreenElement) {
            document.exitFullscreen()
          }
        }
      } else if (type === 'savePgmMute') {
        this.pgmMute = isControlMute
        localStorage.setItem('pgmMute', isControlMute)
      } else if (type == 'showOffSetBtn') {
        this.showOffSetBtn = val
      }
    },
    async recordDeviceStatus () {
      if (!this.userInfo.joinCode) return
      const data = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.userInfo.joinCode,
        key: 'blockVideo',
        value: !this.devicesInfo?.cameraId,
        initiator: this.userInfo.rtilCode + ''
      }, {
        mark: this.userInfo.rtilCode + '',
        annotation: this.userInfo.joinCode,
        key: 'blockAudio',
        value: !this.devicesInfo?.microphoneId,
        initiator: this.userInfo.rtilCode + ''
      },
      {
        mark: this.userInfo.rtilCode + '',
        annotation: this.partyCode,
        key: 'channels',
        value: this.nickNameInfo[this.userInfo.rtilCode],
        initiator: this.userInfo.rtilCode + ''
      }]
      await this.$http.post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/setList`, data)
    },
    async deleteChannels () {
      const data =
        {
          mark: this.userInfo.rtilCode + '',
          annotation: this.partyCode,
          key: 'channels',
          notify: false
        }
      await this.$http.post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/delete`, data)
    },
    // 初始化websocket
    initWebsocket () {
      const row = window.location.protocol === 'http' ? 'ws' : 'wss'
      if (!this.Config || !this.Config.urlInfo) return
      const ccWebsocket = this.Config.urlInfo.ccWebsocket
      const random32Str = Utils.getComRandomStr()
      const businessId = this.userInfo.joinCode + ':' + this.realPartyCode
      const ws = new Websocket({
        url: `${row}://${ccWebsocket}/pageSerBusRequest?taskId=${random32Str}&businessId=${businessId}&notCheckUser=true`,
        sendHeart: true,
        key: 'pageSerBusRequestByPartyCode'
      })
      ws.initWebSocket()
      this.websockets.push(ws)
    },
    async initAMWebsocket (taskId, eventId) {
      if (!taskId || !eventId) return
      await this.$http.get(`/commentator-backend/am/noLogin/getAudioMixerConfig/${eventId}`)
        .then(res => {
          if (res.data.errorCode === '0x0') {
            const { result } = res.data
            if (result) {
              const endpoint = result.graphql
              const extractedHostname = new URL(endpoint).hostname;
              const obj = {
                host: extractedHostname,
                'x-api-key': result.apiKey
              }
              this.amWsversion = result.version
              const jsonStr = JSON.stringify(obj);
              this.encodedData = btoa(jsonStr);
              this.realtimeApiHostname = extractedHostname.replace('appsync-api', 'appsync-realtime-api');
            }
          }
        })
      const row = window.location.protocol === 'http' ? 'ws' : 'wss'
      const clientId = 'commentator_pip_partyCode' + this.partyCode + '_' + Utils.getUUID()
      let url = `${row}://${this.realtimeApiHostname}/ws/graphql?taskId=${taskId}&clientId=${clientId}&origin=commentator`
      let wsType = 'graphql'
      let sendHeart = true
      if (this.amWsversion == 'v2') {
        url = `${row}://${this.realtimeApiHostname}/ws/graphql?taskId=${taskId}&clientId=${clientId}&origin=commentator`
        wsType = 'graphqlV2'
        sendHeart = true
      } else {
        url = `${row}://${this.realtimeApiHostname}/graphql?header=${this.encodedData}&payload=e30=`
        wsType = 'graphql'
        sendHeart = false
      }
      const ws = new Websocket({
        url,
        wsType,
        sendHeart,
        key: 'graphql',
        pairNumber: this.pairNumber,
        taskid: taskId
      })
      ws.initWebSocket()
      this.websockets.push(ws)
    },
    getPairList (taskId, eventId) {
      if (!taskId || !eventId) return
      // 初始化记录4个pair状态
      this.$http.post('/commentator-backend/am/noLogin/getPairList', {
        taskId: taskId,
        eventId: eventId
      })
        .then(res => {
          if (res.data.errorCode === '0x0') {
            if (res.data.result) {
              this.pairNumber = res.data.result.length
              if (this.initJoin) {
                this.initAMWebsocket(taskId, eventId)
                this.initJoin = false
              }
              // 检查是否所有长度一致(解决getPairList接口未返回所有pair的数据时需要再次调用一次)
              const inputDatasArrayLengths = res.data.result.map(item => {
                return item.inputDatas ? item.inputDatas.length : 0
              })
              const allLengthsEqual = inputDatasArrayLengths.every(length => length === inputDatasArrayLengths[0])
              if (!allLengthsEqual) {
                this.getPairList(taskId, eventId)
                return
              }
              res.data.result.forEach((item) => {
                item.inputDatas && item.inputDatas.forEach((itemInput) => {
                  if (itemInput.ID.includes('Commentator')) {
                    const parts = itemInput.ID.split('_');
                    const rtilCode = parts[2];
                    if (itemInput.audioStreams.length != 0) {
                      // 支持左右声道
                      this.$set(this.amStatusInfo, rtilCode, { ...itemInput.audioStreams[0].channelDatas })
                      this.$set(this.allPairStatusInfo, item.ID, { ...this.amStatusInfo })
                    }
                  }
                })
              })
              // 检查是否加入到R
              this.$nextTick(() => {
                if (this.amStatusInfo[this.userInfo.rtilCode]) {
                  const updateParams = {
                    partyCode: this.realPartyCode,
                    rtilCode: this.userInfo.rtilCode,
                    rtilName: localStorage.getItem(`nickName_${this.partyCode}`), // 去掉首尾空格
                    eventId: this.eventInfo.id,
                    toRtilCode: this.userInfo.rtilCode
                  }
                  updateAmSourceName(updateParams)
                }
                // 由于是要把与会者自己的状态显示到mainWindow，所以应该调用mainWindow的结构
                if (this.$refs.mainWindowContent) {
                  this.$refs.mainWindowContent.dealStatus(true)
                }
              })
            }
          }
        })
    },
    async getCurrentEventInfo () {
      try {
        await this.$http
          .post(`/commentator-backend/event/party/noLogin/${this.partyCode}`)
          .then((res) => {
            if (res.data.errorCode === '0x0') {
              this.$store.commit('saveEventInfo', res.data.result)
              // 记录pp事件是否为pgm上mainWindow的状态
              this.eventState()
              if (res.data.result.producerSettingsDto) {
                const { delay } = res.data.result.producerSettingsDto
                this.maxTimeDifference = delay * 1000
              }
            }
          })
      } catch (error) {
        console.error('getCurrentEventInfo error:', error)
      }
    },
    async getGroupInfo () {
      if (!this.eventInfo) return
      await this.$http
        .post(`${this.State.config.urlInfo.partyline}/partyline-backend/coordination/noLogin/group/${this.eventInfo.id}`)
        .then(res => {
          if (res.data.errorCode === '0x0') {
            const { result } = res.data
            result.newGroupSettings && result.newGroupSettings.forEach(item => {
              this.$set(this.groupInfo, item.partyCode, item)
            })
            if (this.realPartyCode) {
              // 初始化哪些 host 和当前的与会者 pushtalk, groupInfo 当刷新进入页面时如果点击 ok 过快会报错，后续优化
              const groupMemberSettingsMap = this.groupInfo[this.realPartyCode]?.groupMemberSettingsMap
              if (this.groupInfo[this.realPartyCode] && groupMemberSettingsMap) {
                Object.keys(groupMemberSettingsMap).forEach(rtilCode => {
                  if (rtilCode == result.rtilCode && groupMemberSettingsMap[rtilCode].length) {
                    groupMemberSettingsMap[rtilCode].forEach(item => {
                      this.$set(this.hostPrivateInfo, item.rtilCode, item.talk == 1)
                    })
                  }
                  // 初始化 pushtalk 状态显示
                  if (groupMemberSettingsMap[rtilCode]) {
                    const array = []
                    groupMemberSettingsMap[rtilCode].forEach(item => {
                      if (item.talk == 1) array.push(item.rtilCode)
                    })
                    this.$set(this.privateInfo, rtilCode, array)
                  }
                })
              }
            }
          }
        })
    },
    async setNameOrJoin () {
      if (this.rtc[this.partyCode]) this.rtc[this.partyCode].leave()
      this.rtc[this.partyCode] = new AgoraClient(this.callBack)
      // 需要先获取设备列表，并判断之前选择过的设备列表是否还存在，不存在则选择默认的
      const devices = this.rtc[this.partyCode] && await this.rtc[this.partyCode].getDevice()
      this.cameraList = devices?.cameraList
      this.microphoneList = devices?.microphoneList
      this.speakerList = devices?.speakerList
      this.speakerId = devices?.speakerId
      this.cameraId = devices?.cameraId
      this.microphoneId = devices?.microphoneId
      this.devicesInfo = {
        cameraId: this.cameraId,
        cameraList: devices?.cameraList,
        microphoneId: this.microphoneId,
        microphoneList: devices?.microphoneList,
        speakerId: this.speakerId,
        speakerList: devices?.speakerList
      }
      this.joinParty() // 有rtilCode代表设置过nickName
    },
    getListAudioSetting () {
      this.$http
        .post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/getList?audioSetting`, {
          annotation: this.userInfo.realPartyCode,
          keys: ['audioSettings'],
          marks: [this.userInfo.rtilCode]
        }).then(res => {
          if (res.data.errorCode === '0x0') {
            const result = res.data.result
            const audioSettings = result[this.userInfo.rtilCode]?.audioSettings || '{}'
            this.$set(this.audioSettingInfo, this.userInfo.rtilCode, JSON.parse(audioSettings))
          }
        })
    },
    joinParty (behaviors) {
      // 解决不同组本地存储相同memberId导致重复加入问题
      const memberId = `particiapntMemberId_${this.partyCode}`
      const haveHistoryMem = localStorage.getItem(memberId)
      let data = []
      data = [
        {
          mark: '',
          annotation: this.partyCode,
          key: 'nickName',
          value: localStorage.getItem(`nickName_${this.partyCode}`),
          notify: true,
          initiator: ''
        },
        {
          mark: '',
          annotation: this.partyCode,
          key: 'speaker',
          value: localStorage.getItem(`speaker_${this.partyCode}`),
          notify: true,
          initiator: ''
        },
        {
          mark: '',
          annotation: this.partyCode,
          key: 'camera',
          value: localStorage.getItem(`camera_${this.partyCode}`),
          notify: true,
          initiator: ''
        },
        {
          mark: '',
          annotation: this.partyCode,
          key: 'mic',
          value: localStorage.getItem(`mic_${this.partyCode}`),
          notify: true,
          initiator: ''
        }
      ]
      const params = {
        memberId: haveHistoryMem || 'commentator_' + new Date().getTime(),
        partyCode: this.partyCode,
        role: 0,
        type: 0,
        password: this.password,
        behaviorKeyList: [
          'speaker',
          'nickName',
          'mic',
          'camera'
        ],
        invitePassCode: localStorage.getItem(`password_${this.partyCode}`),
        behaviors: data
      }
      if (behaviors) params.behaviors = behaviors
      this.$http
        .post(`${this.State.config.urlInfo.partyline}/partyline-backend/party/noLogin/join`, params)
        .then(async (res) => {
          if (res.data.errorCode === '0x0') {
            localStorage.setItem(memberId, params.memberId)
            const result = res.data.result
            const { rtilCode, realPartyCode } = result
            this.userInfo = result
            this.State.userInfo = result
            this.rtilCode = rtilCode
            this.realPartyCode = realPartyCode
            this.outputRtilCode = result.status.output
            this.externalPartyCode = result.externalJoinInfo.join
            const pgmMute = localStorage.getItem('pgmMute')
            this.$set(this.nickNameInfo, rtilCode, localStorage.getItem(`nickName_${this.partyCode}`))
            this.getListAudioSetting()
            if (!pgmMute) {
              localStorage.setItem('pgmMute', false)
            } else {
              this.pgmMute = pgmMute === 'true'
            }

            this.initWebsocket()
            this.recordDeviceStatus()// 用来记录是否有摄像头或者block
            await Promise
              .all([this.getTalkToAllGroup(), this.getTalkToGroup()])
              .then(result => {
                result && result.forEach((item, index) => {
                  if (index === 0) {
                    this.initTalkToAllGroup(item)
                  } else {
                    this.initTalkToGroup(item)
                  }
                })
              })
              .catch((e) => {
                console.log('Init talkToAllGroup and talkToGroup failed.')
              })
            if (this.State?.checkEnv?.userEmail) {
              this.State.checkEnv.userEmail = this.State.checkEnv.userEmail.toLowerCase()
            }
            if (
              this.rtc[this.partyCode]._AgoraRTC &&
              this.State?.checkEnv?.userEmail?.includes('tvunetworks')
            ) {
              this.rtc[this.partyCode]._AgoraRTC.setLogLevel(0)
              this.rtc[this.partyCode]._AgoraRTC.enableLogUpload()
            }
            if (JSON.stringify(this.groupInfo) != '{}') {
              const groupMemberSettingsMap = this.groupInfo[this.realPartyCode]?.groupMemberSettingsMap
              if (this.groupInfo[this.realPartyCode] && groupMemberSettingsMap) {
                Object.keys(groupMemberSettingsMap).forEach(rtilCode => {
                  if (rtilCode == result.rtilCode && groupMemberSettingsMap[rtilCode].length) {
                    groupMemberSettingsMap[rtilCode].forEach(item => {
                      this.$set(this.hostPrivateInfo, item.rtilCode, item.talk == 1)
                    })
                  }
                  // 初始化 pushtalk 状态显示
                  if (groupMemberSettingsMap[rtilCode]) {
                    const array = []
                    groupMemberSettingsMap[rtilCode].forEach(item => {
                      if (item.talk == 1) array.push(item.rtilCode)
                    })
                    this.$set(this.privateInfo, rtilCode, array)
                  }
                })
              }
            }
            this.joinChannel({ ...result, memberId: params.memberId })
          } else if (res.data.errorCode === '80520113') {
            this.$message.error(this.$t('preview.partyDisabled'))
            if (this.$route.name !== 'remove') {
              this.$router.push({ name: 'remove', query: { type: 'disableParty' } })
            }
          } else if (res.data.errorCode === '80520107') {
            if (this.$route.name !== 'remove') {
              this.$router.push({ name: 'remove', query: { type: 'needPassCode', partyCode: this.partyCode } })
            }
          } else if (
            res.data.errorCode === '82201504' ||
              res.data.errorCode === '82201505' ||
              res.data.errorCode === '82201506'
          ) {
            if (this.$route.name != 'remove') {
              this.$router.push({
                name: 'remove',
                query: {
                  type: 'notExist'
                }
              })
            }
          } else {
            this.$message.error(res.data.errorInfo)
          }
        })
    },
    getTalkToAllGroup () {
      return this.$http
        .post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/getList?allGroup`, {
          originRtilCode: this.userInfo.rtilCode,
          annotation: this.userInfo.joinCode,
          keys: ['talkToAllGroup'],
          marks: this.userInfo.managerRtils
        })
    },
    initTalkToAllGroup (res) {
      if (res.data.errorCode === '0x0') {
        const hostMap = res.data.result
        if (hostMap) {
          const array = []
          Object.keys(hostMap).forEach(rtilCode => {
            if (hostMap[rtilCode].talkToAllGroup && hostMap[rtilCode].talkToAllGroup == '1') {
              this.$set(this.hostPrivateInfo, rtilCode, 1)
              this.talkToAllGroupList.push(rtilCode)
              array.push(rtilCode)
            }
          })
          this.$set(this.privateInfo, this.userInfo.rtilCode, array)
        }
      }
    },
    getTalkToGroup () {
      return this.$http
        .post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/getList?toGroup`, {
          originRtilCode: this.userInfo.rtilCode,
          annotation: this.userInfo.realPartyCode,
          keys: ['talkToGroup'],
          marks: this.userInfo.managerRtils
        })
    },
    initTalkToGroup (res) {
      if (res.data.errorCode === '0x0') {
        const hostMap = res.data.result
        if (hostMap) {
          const array = []
          Object.keys(hostMap).forEach(rtilCode => {
            if (hostMap[rtilCode].talkToGroup && hostMap[rtilCode].talkToGroup == '1') {
              this.$set(this.hostPrivateInfo, rtilCode, 1)
              this.talkToGroupList.push(rtilCode)
              array.push(rtilCode)
            }
          })
          if (this.privateInfo[this.userInfo.rtilCode].length) {
            const concatArray = this.privateInfo[this.userInfo.rtilCode].concat(array)
            this.$set(this.privateInfo, this.userInfo.rtilCode, concatArray)
          } else {
            this.$set(this.privateInfo, this.userInfo.rtilCode, array)
          }
        }
      }
    },
    async joinChannel (joinInfo) {
      // 初始化状态
      this.State.isMute = localStorage.getItem(`speaker_${this.partyCode}`) === 'false'
      this.videoSelf = localStorage.getItem(`camera_${this.partyCode}`) !== 'false'
      this.muteAudioSelf = localStorage.getItem(`mic_${this.partyCode}`) === 'false'
      const quality = this.State.eventInfo.advancedSetting && this.State.eventInfo.advancedSetting.quality
      // 为了修改初始以 mute 加入时，底部栏 mic 状态不对的问题
      this.hadPushTalk = !this.muteAudioSelf
      this.$set(this.muteAudioObj, this.userInfo.rtilCode, this.muteAudioSelf)
      const { appId, tokenCode, rtilCode, realPartyCode, videoQualities } = joinInfo
      await this.setPreviewAudioSetting()
      await this.getAudioSetting()
      const params = {
        appId,
        channel: realPartyCode + '',
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        videoConfig: videoQualities,
        cameraId: this.devicesInfo?.cameraId,
        microphoneId: this.devicesInfo.microphoneId,
        video: !!this.devicesInfo?.cameraId,
        audio: !!this.devicesInfo.microphoneId,
        publishVideo: true,
        publishAudio: !this.muteAudioSelf,
        muteAudio: this.muteAudioSelf,
        audioProfile: this.audioQualityPreset || 'high_quality',
        sendMetadata: joinInfo.status.forwardMetadata === true,
        startProxy: joinInfo.status.cloudProxy === 1,
        checkedAec: this.checkedAec,
        checkedAns: this.checkedAns,
        checkedAgc: this.checkedAgc,
        getRemoteNetworks: true,
        getLocalVideoParams: true,
        quality: quality && quality != '360p' ? quality : ''
      }
      // this.rtc[realPartyCode] = new AgoraClient(this.callBack)
      const uid = await this.rtc[realPartyCode].join(params)
      if (!uid) return
      this.hadOpenWebCloud = true
      this.rtcLoaded = true
      console.log('Test delay join Agora success: ', Date.now(), new Date())
      // 加入过real channel之后再加入external channel不然会有冲突
      this.joinExternal(joinInfo)
    },
    joinExternal (joinInfo) {
      const externalJoinInfo =
        joinInfo.externalJoinInfo.externalPartyInfo[0].joinInfo
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        videoQualities
      } = externalJoinInfo
      const params = {
        appId: appId,
        channel: realPartyCode + '',
        token: tokenCode,
        uid: rtilCode,
        cameraId: this.devicesInfo?.cameraId,
        microphoneId: this.devicesInfo?.microphoneId,
        publish: false,
        audio: false,
        videoConfig: videoQualities,
        subscribeRemote: false,
        sendMetadata: true,
        startProxy: joinInfo.status.cloudProxy === 1,
        getRemoteNetworks: true
      }
      this.rtc[realPartyCode] = new AgoraClient(this.callBack)
      this.rtc[realPartyCode].join(params)
    },
    // 1.与会者发了流没处理好 2.与会者没发流 3.host没接收到

    async callBack ({ action, payload }) {
      const { uid, channel, audioTrack, videoTrack, changeDevice } = payload
      // if (action != 'volumeList' && action != 'receiveMetadata' && action != 'unlinkQuality' && action != 'remoteVideoStatus') {
      //   console.info(139, action, payload)
      // }
      switch (action) {
        case 'user-joined':
          this.userJoin(payload)
          break
        case 'unlinkQuality':
          Bus.$emit('setUnlinkQuality', payload)
          break
        case 'user-left':
          this.userLeave(payload)
          break
          // 自己发的流
        case 'local-track':
          if (uid == this.userInfo.rtilCode && channel == this.realPartyCode && audioTrack) {
            const localAudioTrack = audioTrack
            try {
              this.State.volumeBar?.addAudioTrack(uid, localAudioTrack._mediaStreamTrack, (volumeLeft, volumeRight) => {
                const dbLeftVal = 20 * Math.log10(volumeLeft * 16)
                const dbRightVal = 20 * Math.log10(volumeRight * 16)
                const ampLeft = !this.hadPushTalk ? 0 : Math.max(dbLeftVal / 60 + 0.8, 0)
                const ampRight = !this.hadPushTalk ? 0 : Math.max(dbRightVal / 60 + 0.8, 0)

                this.canvasDrap(uid + 'Left', ampLeft)
                this.canvasDrap(uid + 'Right', ampRight)
                // Me设置私聊功能，使用到
                this.meInfo = {
                  id: this.userInfo.rtilCode,
                  channel: this.userInfo.realPartyCode,
                  videoTrack: null,
                  audioTrack: null // 本地视频不需要播放audio
                }
                // 过滤自己和开启mic情况
                if (!this.hadPushTalk && !this.manualShutdown && !this.hasTalkback && !this.hasHostTalkback && !this.hasPipTalkback) {
                // 检测到有音频判断条件
                  const hasAudio = volumeLeft > 0 || volumeRight > 0

                  if (hasAudio) {
                    // 检测到说话，重置无声监测计时器
                    if (!this.isSpeaking && !this.speakTimer) {
                      // 第一次检测到说话时设置计时器
                      this.speakTimer = setTimeout(() => {
                        this.isSpeaking = true;
                        this.speakInfo.speaking = true;
                        console.log('有人说话');
                      }, 1000); // 设置在2秒后执行说话逻辑
                    }
                    // 如果已经在说话，重置无声状态的计时器
                    clearTimeout(this.silenceTimer);
                    this.silenceTimer = null;
                  } else {
                    clearTimeout(this.speakTimer);
                    this.speakTimer = null;
                    // 检测到无声，处理无声情况
                    if (this.isSpeaking && !this.silenceTimer) {
                      this.silenceTimer = setTimeout(() => {
                        this.isSpeaking = false;
                        this.speakInfo.speaking = false;
                        console.log('2秒内未检测到音频');
                      }, 2000); // 设置在5秒无声后执行无声结束逻辑
                    }
                    // 未检测到声音且说话计时器存在时先清除说话计时器
                    // clearTimeout(speakTimer);
                    // speakTimer = null;
                  }
                }
              })
            } catch (error) {
              console.log('destroyAudioContext error:', error)
            }
          }
          // 自动切换摄像头时候设备列表更新
          if (this.rtc[this.realPartyCode]?._localVideoTrack && !payload.notExecuteDeviceListUpdate) {
            const videoLabel = this.rtc[this.realPartyCode]._localVideoTrack.getTrackLabel()
            this.devicesInfo?.cameraList.forEach(item => {
              if (item.label === videoLabel) {
                this.devicesInfo.cameraId = item.deviceId
              }
            })
          }
          // 添加如果后台返回是禁用摄像头状态，发黑帧的逻辑
          if (this.userInfo.behavior && this.userInfo.behavior.camera === 'false' && videoTrack && videoTrack._originMediaStreamTrack) {
            videoTrack._originMediaStreamTrack.enabled = false
          }

          if (this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode]._localAudioTrack) {
            this.detecteMicMuted()
            // 新增判断 feedback 功能是否开启
            if (this.State.enableFeedback && !this.muteAudioObj[this.userInfo.rtilCode]) {
              this.rtc[this.realPartyCode]._localAudioTrack.play()
            }
          }
          break
          // 订阅远程的流（与会者加进来）
        case 'subscribe-track':
          this.subscribeTrack(payload)
          break
        case 'unsubscribe-track':
          if (payload.type == 'audio') {
            this.$set(this.channels, payload.id, {
              ...this.channels[payload.id],
              audioTrack: null
            })
            console.info(236, payload.audioTrack)
          }
          break
        case 'volumeList':
          payload.forEach((volume) => {
            this.$set(this.voiceList, volume.uid, volume)
          })
          break
          // 接收远程发来的流
        case 'user-published':
        case 'user-unpublished':
          this.muteAudioOrVideo(action, payload)
          break
        case 'receiveMetadata':
          this.dealMetadata(payload)
          break
        case 'localVideoStatus':
          Bus.$emit('seLocalVideoParams', payload)
          break
        case 'remoteVideoStatus':
          Bus.$emit('setMainWindowVideoParams', payload)
          break
        case 'changeDevice':
          if (payload.success === 'success') {
            localStorage.setItem(payload.type, payload.deviceId)
          }
          break
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true
          }
          break
        case 'cameraChange':
          this.devicesInfo = await this.rtc[this.realPartyCode]?.getDevice()
          if (this.rtc[this.realPartyCode]?._localVideoTrack && changeDevice.device.label === this.rtc[this.realPartyCode]._localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc[this.realPartyCode]._AgoraRTC.getCameras()
            oldCameras[0] && this.rtc[this.realPartyCode].setDevice(oldCameras[0].deviceId, 'video', '', (type) => {
              type === 'success' ? this.$message.success(this.$t('coordinationParticipant.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('coordinationParticipant.autoSwitchNewCameraFailed'))
              this.devicesInfo.cameraId = oldCameras[0].deviceId
            })
          }
          break
        case 'micChange':
          this.devicesInfo = this.rtc[this.realPartyCode] && await this.rtc[this.realPartyCode].getDevice()
          if (this.rtc[this.realPartyCode]?._localAudioTrack &&
          (
            (this.rtc[this.realPartyCode]._localAudioTrack._deviceName.includes(changeDevice.device.label)) ||
            (changeDevice.state === 'INACTIVE' && this.rtc[this.realPartyCode]._localAudioTrack._config.microphoneId == 'default')
          )) {
            const oldMic = await this.rtc[this.realPartyCode]._AgoraRTC.getMicrophones()
            oldMic[0] && this.rtc[this.realPartyCode].setDevice(oldMic[0].deviceId, 'audio', 'needLocalAudioTrack', (type) => {
              type === 'success' ? this.$message.success(this.$t('coordinationParticipant.autoSwitchNewMicSuccess')) : this.$message.error(this.$t('coordinationParticipant.autoSwitchNewMicFailed'))
              this.devicesInfo.microphoneId = oldMic[0].deviceId
              this.detecteMicMuted()
            })
          } else if (changeDevice.state === 'ACTIVE' &&
            this.rtc[this.realPartyCode]?._localAudioTrack &&
            !this.rtc[this.realPartyCode]._localAudioTrack._deviceName?.includes(changeDevice.device.label) &&
            this.rtc[this.realPartyCode]._localAudioTrack._config?.microphoneId == 'default') {
          // 插入mic
            if (this.hadPushTalk && this.rtc[this.realPartyCode]) {
              this.rtc[this.realPartyCode].setEnabled(false, 'audio')
              this.rtc[this.realPartyCode].setEnabled(true, 'audio')
              this.detecteMicMuted()
            }
            if (this.devicesInfo.microphoneList?.[0]?.label != this.rtc[this.realPartyCode]?._localAudioTrack?._deviceName) { this.$message.success(this.$t('coordinationParticipant.autoSwitchNewMicSuccess')) }
          }
          break
        case 'playbackChange':
          if (!this.rtc[this.realPartyCode]) return
          this.devicesInfo = this.rtc[this.realPartyCode] && await this.rtc[this.realPartyCode].getDevice()
          if (changeDevice.state === 'ACTIVE' && this.rtc[this.realPartyCode]._localAudioTrack) {
            localStorage.setItem('speakerId', this.devicesInfo.speakerList[0].deviceId)
            this.devicesInfo.speakerId = this.devicesInfo.speakerList[0].deviceId
          } else {
            try {
              const oldSpeaker = await this.rtc[this.realPartyCode]._AgoraRTC.getPlaybackDevices()
              localStorage.setItem('speakerId', oldSpeaker[0].deviceId)
              this.devicesInfo.speakerId = oldSpeaker[0].deviceId
            } catch (e) {
              console.log('get mic list failed')
            }
          }
          break
        case 'autoPlayFailed':
          this.$alert(this.$t('coordinationParticipant.autoPlayFailed'), {
            confirmButtonText: this.$t('coordinationRoom.ok'),
            customClass: 'autoplayFailed',
            confirmButtonClass: 'joinBtn',
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false
          }).then(() => {})
          break
      }
    },
    muteAudioOrVideo (action, payload) {
      const { id, channel, mediaType } = payload
      if (action === 'user-unpublished') {
        if (payload.mediaType === 'video') {
          this.$set(this.videoObj, id, false)
        } else {
          this.$set(this.muteAudioObj, id, true)
        }
      } else {
        if (this.outputRtilCode == id && this.externalPartyCode == channel) {
          this.rtc[this.externalPartyCode] && this.rtc[this.externalPartyCode].subscribe(id, mediaType)
        }
        if (payload.mediaType === 'video') {
          this.$set(this.videoObj, id, true)
        } else {
          this.$delete(this.muteAudioObj, id)
        }
      }
    },
    async userJoin (payload) {
      if (!payload) return
      await this.$http
        .post(`${this.State.config.urlInfo.partyline}/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`)
        .then((res) => {
          if (res.data.errorCode === '0x0') {
            const result = res.data.result
            const accountId = result.accountId.toLowerCase()
            this.getNickName(payload.id)
            if (result.deviceType !== 'R') {
              if (this.channels[payload.id] && (this.channels[payload.id].audioTrack || this.channels[payload.id].videoTrack)) return
            }
            if (this.outputRtilCode && this.outputRtilCode == payload.id && this.externalChannel.id != payload.id) {
              const obj = {
                ...payload,
                tid: accountId
              }
              this.externalChannel = obj
            }
            if (this.talkToAllGroupList.length) {
              const array = []
              this.talkToAllGroupList.forEach(rtilCode => {
                array.push(rtilCode)
              })
              this.$set(this.privateInfo, payload.id, array)
            }
            if (this.talkToGroupList.length) {
              const array = []
              this.talkToGroupList.forEach(rtilCode => {
                array.push(rtilCode)
              })
              if (this.privateInfo[payload.id] && this.privateInfo[payload.id].length) {
                const concatArray = this.privateInfo[payload.id].concat(array)
                this.$set(this.privateInfo, payload.id, concatArray)
              } else {
                this.$set(this.privateInfo, payload.id, array)
              }
            }
          }
        })
    },
    setNickName (data) {
      this.joinParty(data)
    },
    async getNickName (id) {
      await this.$http
        .post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/getList`, {
          originRtilCode: this.userInfo.rtilCode,
          annotation: this.userInfo.joinCode,
          keys: ['nickName', 'camera', 'mic', 'blockAudio', 'blockVideo', 'host'],
          marks: [id]
        })
        .then((res) => {
          if (res.data.errorCode === '0x0') {
            const result = res.data.result[id]
            if (!this.nickNameInfo[id]) {
              this.$set(this.nickNameInfo, id, result.nickName)
            }
            this.$set(this.muteAudioObj, id, result.mic === 'false')
            this.$set(this.videoObj, id, result.camera === 'true')
          }
        })
    },
    userLeave (payload) {
      const { id, channel } = payload
      const _this = this
      this.$delete(_this.channels, id)
      this.$delete(this.privateInfo, id)
      if (channel == this.externalPartyCode && id == this.externalChannel.id) {
        this.externalChannel = {}
      }
      if (this.userInfo.managerRtils.includes(id) && this.talkToGroupList.includes(id)) {
        this.talkToGroupList = this.talkToGroupList && this.talkToGroupList.filter(rtilCode => {
          return rtilCode != id
        })
      }
      if (this.userInfo.managerRtils.includes(id) && this.talkToAllGroupList.includes(id)) {
        this.talkToAllGroupList = this.talkToAllGroupList && this.talkToAllGroupList.filter(rtilCode => {
          return rtilCode != id
        })
      }
      // 清除频道信息
      const data =
          {
            mark: id + '',
            annotation: this.partyCode,
            key: 'channels',
            notify: false
          }
      this.$http.post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/delete`, data)
      this.$set(this.videoObj, payload.id, false)
      this.$set(this.muteAudioObj, payload.id, false)
    },
    subscribeTrack (payload) {
      try {
        // 创建可以播放的mediastream
        const { id, channel, videoTrack, audioTrack } = payload

        // 音量柱的显示
        const media = new MediaStream()
        if (videoTrack) {
          media.addTrack(videoTrack._mediaStreamTrack)
          if (id === this.outputRtilCode) {
            // this.getMainwindowPTS(videoTrack._mediaStreamTrack)
            videoTrack.on('sei-received', (sei) => {
              const textDecoder = new TextDecoder()
              const text = textDecoder.decode(sei)
              this.seiInfo = JSON.parse(text)
              // try {
              //   // console.log('sei-received: ', JSON.parse(text))
              // } catch (e) {
              //   console.log(error)
              // }
            })
          }
        }
        if (audioTrack && this.talkBackType != 'callHost' || (this.talkBackType == 'callHost' && id != this.noCallBackRtilCode)) {
          media.addTrack(audioTrack._mediaStreamTrack)
          audioContextObj.audioTrack(media, id)
          setTimeout(() => {
            audioContextObj.resumeAudio(id)
          }, 1000)
        }

        // 不接收 host 在 externalChannel 里的流
        if (this.userInfo.managerRtils.includes(id) && channel == this.externalPartyCode) return

        if (this.userInfo.managerRtils.includes(id) && channel == this.realPartyCode) {
          if (this.hostPrivateInfo[id]) {
            const obj = {}
            obj.id = id
            obj.videoTrack = videoTrack
            obj.audioTrack = audioTrack
            this.$set(this.hostInfo, id, obj)
          }
        } else if (this.externalPartyCode == channel) {
          if (payload.id == this.outputRtilCode) {
            const obj = {}
            obj.id = id
            obj.videoTrack = videoTrack
            obj.audioTrack = audioTrack
            obj.channel = channel
            this.externalChannel = obj
          }
        } else {
          const obj = Object.assign({}, this.channels[payload.id])
          obj.id = id
          obj.videoTrack = videoTrack
          obj.audioTrack = audioTrack
          obj.channel = channel
          if (this.talkBackType == 'callHost') {
            if (this.noCallBackRtilCode && id != this.noCallBackRtilCode) {
              this.$set(this.channels, payload.id, obj)
            } else if (this.noCallBackRtilCode && id == this.noCallBackRtilCode) {
              if ((this.audioStatus && JSON.parse(this.audioStatus)) || (this.channels[this.noCallBackRtilCode] && this.channels[this.noCallBackRtilCode].audioTrack)) {
                this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].unsubscribe(this.noCallBackRtilCode, 'audio')
              }
            }
          } else {
            this.$set(this.channels, payload.id, obj)
          }
        }
      } catch (error) {
        console.info(error)
      }
    },
    async getMainwindowPTS (videoTrack) {
      if ('MediaStreamTrackProcessor' in window && 'VideoDecoder' in window) {
        const processor = new MediaStreamTrackProcessor({ track: videoTrack })
        const reader = processor.readable.getReader()

        const { done, value } = await reader.read();
        if (done) return;

        const frame = value;
        const ptsSeconds = frame.timestamp // 转换为秒

        console.log(`视频帧 PTS: ${ptsSeconds} 秒`)

        // 如果需要，可以在这里添加逻辑来处理关键帧
        // 例如，通过某种算法检测关键帧特征

        frame.close();

        // const decoder = new VideoDecoder({
        //   output: this.handleFrame,
        //   error: (e) => console.error(e)
        // })

        // decoder.configure({
        //   codec: 'vp8' // 根据实际编码类型调整
        // })

        // async function processStream () {
        //   while (true) {
        //     const { done, value } = await reader.read();
        //     if (done) break;
        //     decoder.decode(value);
        //   }
        //   decoder.close()
        // }

        // processStream()
      } else {
        console.error('浏览器不支持 MediaStreamTrackProcessor 或 VideoDecoder')
      }
    },
    handleFrame (frame) {
      const pts = frame.timestamp / 1000000; // 转换为秒
      if (frame.keyFrame) {
        console.log(`关键帧 PTS: ${pts} 秒`);
        // 在此处处理关键帧，例如存储 PTS 等
      }
      frame.close();
    },
    async dealMetadata (payload) {
      // metadata首先external和realparty先各发一次，但是只有在external接收到消息的时候才去做转发
      // jira链接:https://tvunetworks.atlassian.net/browse/PL-3072
      const { metadataInfo, channel } = payload
      if (this.externalPartyCode == channel && this.rtc[this.realPartyCode]._client && this.rtc[this.realPartyCode]._client._joinAndNotLeaveYet) {
        if (this.userInfo.status.forwardMetadata === true && !this.switchVal) {
          const info = JSON.parse(this.Uint8ArrayToString(metadataInfo))
          // 应用当前偏移值， timeStamp用于rtil decoder
          info.timestamp += this.timestampOffset
          info.rtil = this.userInfo.rtilCode
          // 为了兼容 tvua 的逻辑,AM可以统一处理
          info.vframe_pts = info.timestamp
          info.local_time = Date.now()
          if (this.seiSwitch) {
            // 视频流中添加SEI数据
            const encoder = new TextEncoder()
            const seiData = encoder.encode(JSON.stringify(info))
            // 只能使用本地host的tracks去调用
            this.rtc[this.realPartyCode]?._localVideoTrack?.sendSeiData(seiData)
          } else {
            try {
              this.rtc[this.realPartyCode]._client.sendMetadata(
                new TextEncoder().encode(JSON.stringify(info)),
                function (error) {
                  if (error) console.log('sendMetadata', error)
                }
              )
            } catch {
              console.log('send metadat failed')
            }
          }
        } else {
          // 切为与会者为pgm时，metadata应该发null，而不是不发；相反metadata正常发
          const obj = {}
          obj.rtil = this.userInfo.rtilCode
          obj.vframe_pts = Date.now()
          try {
            this.rtc[this.realPartyCode]._client.sendMetadata(
              new TextEncoder().encode(JSON.stringify(obj)),
              function (error) {
                if (error) console.log('sendMetadata', error)
              }
            )
          } catch {
            console.log('send metadata failed')
          }
        }
        const info = this.Uint8ArrayToString(metadataInfo)
        const timestamp = JSON.parse(info).timestamp
        const timeCode = JSON.parse(info).timeCode
        this.metaDataTimeCode = timeCode
        this.metaDateTimeStamp = this.getFullTimestamp(timestamp)
      }
    },
    getFullTimestamp (timeStamp) {
      if (!timeStamp) return ''
      const pad = (n, s = 2) => {
        const str = String(n)
        return str.padStart(s, '0')
      }
      // const pad = (n, s = 2) => (`${new Array(s).fill(0)}${n}`).slice(-s)
      const d = new Date(timeStamp)
      return `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(), 3)}`
    },
    Uint8ArrayToString (fileData) {
      let dataString = ''
      for (let i = 0; i < fileData.length; i++) {
        dataString += String.fromCharCode(fileData[i])
      }
      return dataString
    },
    showDialog () {
      this.leaveTips.show = true
      this.leaveTips.content = this.$t('coordinationParticipant.leavePartyContent')
    },
    async setOperate ({ type, id }) {
      // 防止点击过快
      const currentTime = Date.now()
      if (type === 'muteVideo') {
        if (currentTime - this.lastDisableCamera < 1000) {
          if (this.initVideoPopup) {
            this.initVideoPopup = !this.initVideoPopup
            this.$message.warning(this.$t('coordinationParticipant.notOperateFrequery'))
          }
          return
        } else {
          this.initVideoPopup = true
        }
        this.lastDisableCamera = currentTime
      }
      if (type === 'muteAudio') {
        if (this.osLevelmicMuted && this.hadPushTalk) {
          this.showMicMutedInfo.show = true
          return
        }
        if (currentTime - this.lastDisableMic < 1000) {
          if (this.initAudioPopup) {
            this.initAudioPopup = !this.initAudioPopup
            this.$message.warning(this.$t('coordinationParticipant.notOperateFrequery'))
          }
          return
        } else {
          this.initAudioPopup = true
        }
        this.lastDisableMic = currentTime
      }
      // <!--防止频繁点击代码结束-->
      if (this.hasTalkback || this.hasHostTalkback || this.hasPipTalkback) return

      const _this = this
      if (type === 'muteVideo') {
        _this.videoSelf = !_this.videoSelf
        this.$set(this.videoObj, this.userInfo.rtilCode, !this.videoSelf)
        // 添加测试 mute 但是发黑帧的逻辑
        if (this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode]._localVideoTrack && this.rtc[this.realPartyCode]._localVideoTrack._originMediaStreamTrack) {
          this.rtc[this.realPartyCode]._localVideoTrack._originMediaStreamTrack.enabled = !this.rtc[this.realPartyCode]._localVideoTrack._originMediaStreamTrack.enabled
        }
        this.changeBehaviorStatus('camera', this.videoSelf)
      } else {
        this.muteAudioSelf = !this.muteAudioSelf
        this.$set(this.muteAudioObj, this.userInfo.rtilCode, this.muteAudioSelf)
        if (this.muteAudioSelf && this.rtc[this.realPartyCode]) {
          this.rtc[this.realPartyCode].unpublish(['audio'])
        } else {
          if (this.rtc[this.realPartyCode]) {
            console.log('log: publish local audio', new Date().getTime())
            this.rtc[this.realPartyCode].publish(['audio'])
          }
        }
        this.changeBehaviorStatus('mic', !this.muteAudioSelf)
        this.setMicTalk(this.muteAudioSelf)
      }
    },
    setMicTalk (val) {
      if (!this.rtilCode || !this.realPartyCode) return
      this.hadPushTalk = !val
      const params = {
        rtilCode: this.rtilCode,
        partyCode: this.realPartyCode,
        timestamp: Date.now()
      }
      const url = this.hadPushTalk ? '/commentator-backend/commentator/party/noLogin/enableMic' : '/commentator-backend/commentator/party/noLogin/disableMic'
      this.$http.post(url, params)
        .then((res) => {
          // 新增加判断当前是否有有开启 feedback
          if (res.data.errorCode === '0x0') {
            if (!val && this.State.enableFeedback && this.rtc?.[this.realPartyCode]?._localAudioTrack) {
              this.rtc[this.realPartyCode]._localAudioTrack.play()
            } else {
              this.rtc?.[this.realPartyCode]?._localAudioTrack?.stop()
            }
          }
        })
    },
    changeDevice (obj) {
      // if (!this.devicesInfo.cameraId) return
      if (obj.type == 'audio') {
        this.rtc[this.realPartyCode].setDevice(obj.deviceId, obj.type, obj.type === 'audio' ? 'needLocalAudioTrack' : '')
        this.detecteMicMuted()
      } else if (obj.type == 'speaker') {
        if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
          this.$message({
            type: 'warning',
            message: this.$t('coordinationParticipant.notSupportSwitchSpeaker')
          })
          return
        }
        localStorage.setItem('speakerId', obj.deviceId)
        // mainWindow
        this.$refs.mainWindowContent.setSpeaker()
        // 与会者
        // this.$refs.talentCommentator.setSpeaker()
        // host
        if (this.rtc[this.realPartyCode]) {
          Object.keys(this.rtc[this.realPartyCode]._remotePublishUser).forEach(rtilCode => {
            if (this.rtc[this.realPartyCode]._remotePublishUser[rtilCode] && this.rtc[this.realPartyCode]._remotePublishUser[rtilCode].audioTrack) {
              this.rtc[this.realPartyCode]._remotePublishUser[rtilCode].audioTrack.setPlaybackDevice(localStorage.getItem('speakerId')).catch(() => {})
              this.rtc[this.realPartyCode]._remotePublishUser[rtilCode].audioTrack.play()
            }
          })
        }
      } else {
        this.rtc[this.realPartyCode].setDevice(obj.deviceId, obj.type, obj.type === 'audio' ? 'needLocalAudioTrack' : '', (type) => {
          if (obj.type === 'video' && !this.videoSelf) {
            if (this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode]._localVideoTrack && this.rtc[this.realPartyCode]._localVideoTrack._originMediaStreamTrack) {
              this.rtc[this.realPartyCode]._localVideoTrack._originMediaStreamTrack.enabled = false
            }
          }
        })
      }
    },
    // 更新设备id
    updateDeviceId (type, info) {
      if (type == 'video') {
        this.devicesInfo.cameraId = info
      } else if (type == 'audio') {
        this.devicesInfo.microphoneId = info
      } else {
        this.devicesInfo.speakerId = info
      }
    },
    changeMute (val) {
      this.$store.commit('isMute', !this.isMute)
      if (val) {
        this.$message({
          type: 'success',
          message: this.$t('coordinationParticipant.websiteSoundOn')
        })
      } else {
        this.$message({
          type: 'success',
          message: this.$t('coordinationParticipant.websiteSoundOff')
        })
      }
      this.changeBehaviorStatus('speaker', !this.isMute)
    },
    changeBehaviorStatus (key, value) {
      if (!this.externalPartyCode) return
      const params = [
        {
          mark: this.userInfo.rtilCode + '',
          annotation: this.externalPartyCode,
          key,
          value,
          notify: true
        }
      ]
      this.$http.post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/setList`, params)
        .then(res => {
          if (res.data.errorCode === '0x0') {
            localStorage.setItem(`${key}_${this.partyCode}`, value)
          }
        })
    },
    newSetPushTalk (val, type) {
      if (!this.rtilCode || !this.realPartyCode) return
      const params = {
        rtilCode: this.rtilCode,
        partyCode: this.realPartyCode,
        timestamp: Date.now()
      }
      const url = val ? '/commentator-backend/commentator/party/noLogin/enableTalkback' : '/commentator-backend/commentator/party/noLogin/disableTalkback'
      this.$http
        .post(url, params)
        .then(res => {
          // 防止执行过 enable 后无法执行 onpinterup
          if (!val) {
            this.leaveCallAllIcon = false
            this.leaveCallRoomIcon = false
            this.leaveCallGroupIcon = false
          }
          if (res.data.errorCode === '0x0') {
            if (type === 'callAll') this.hasTalkback = val
            if (type === 'callHost') this.hasHostTalkback = val
            if (type === 'callPip') this.hasPipTalkback = val
            this.talkbackLoading = false
            this.talkbackRoomLoading = false
            this.talkbackGroupLoading = false
            this.changeTalkbackBehavior(type, val)
            // 如果当前麦克风被禁用，药打开声音
            if (!this.hadPushTalk && val) {
              this.openMicTalkBack()
            } else if (!this.hadPushTalk && !val) {
              this.closeMicTalkBack()
            }
          }
        })
    },
    // 判断当前的麦克风是否开启如果没有需要创建流
    openMicTalkBack () {
      if (this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode]._localAudioTrack) {
        this.rtc[this.realPartyCode].publish(['audio'])
        // 新增判断当前是否打开 feedback
        if (this.State.enableFeedback) {
          this.rtc[this.realPartyCode]._localAudioTrack.play()
        }
      }
    },
    closeMicTalkBack () {
      if (this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode]._localAudioTrack) {
        this.rtc[this.realPartyCode].unpublish(['audio'])
        if (this.State.enableFeedback && this.muteAudioObj[this.userInfo.rtilCode]) {
          this.rtc[this.realPartyCode]._localAudioTrack.stop()
        }
      }
    },
    delayControlTalkback (val, type) {
      // 加 600ms 延迟是因为后端有 500ms 快速点击的校验，不添加这个后端接收的消息顺序可能会是反的，进而影响 AM 和 Commentator 的状态一致
      if (this.dealySendTalkTimer) clearTimeout(this.dealySendTalkTimer)
      this.dealySendTalkTimer = setTimeout(() => {
        this.newSetPushTalk(val, type)
      }, 600)
    },
    onPointerDown (e, type) {
      if (
        (type === 'callAll' && (this.hasHostTalkback || this.hasPipTalkback)) ||
        (type === 'callHost' && (this.hasTalkback || this.hasPipTalkback)) ||
        (type === 'callPip' && (this.hasTalkback || this.hasHostTalkback))
      ) {
        this.$message.warning(this.$t('coordinationParticipant.talkBackConflict'))
        return
      }
      e?.preventDefault?.()
      this.isLongPress = false
      if (this.sendTalkbackTimer) {
        clearTimeout(this.sendTalkbackTimer)
        this.sendTalkbackTimer = null
      }
      console.log('log isLongPress down:', this.isLongPress)
      this.sendTalkbackTimer = setTimeout(() => {
        this.isLongPress = true
        console.log('log isLongPress set down:', this.isLongPress)
        if (type === 'callAll') this.talkbackLoading = true
        if (type === 'callHost') this.talkbackRoomLoading = true
        if (type === 'callPip') this.talkbackGroupLoading = true
        this.newSetPushTalk(true, type)
      }, 500)
    },
    onPointerUp (type, by) {
      this.hasKeyDown = false
      if (this.sendTalkbackTimer) clearTimeout(this.sendTalkbackTimer)
      // 长按时松手和在 loading 时都要发送
      console.log('log isLongPress up:', this.isLongPress, type, 'from:', by)
      // 为了防止拖动手表移除到 icon 外时松手并且 enable 接口还没返回，而导致不触发 disable
      if (
        this.isLongPress ||
        (type === 'callAll' && this.leaveCallAllIcon) ||
        (type === 'callHost' && this.leaveCallRoomIcon) ||
        (type === 'callPip' && this.leaveCallGroupIcon)
      ) {
        if (type === 'callAll') this.talkbackLoading = true
        if (type === 'callHost') this.talkbackRoomLoading = true
        if (type === 'callPip') this.talkbackGroupLoading = true
        this.delayControlTalkback(false, type)
      } else {
        this.$message.warning(this.$t('coordinationParticipant.quicklyTalkFailed'))
      }
    },
    changeTalkbackBehavior (key, value) {
      if (!this.userInfo.rtilCode || !this.eventInfo || !this.eventInfo.id || !this.realPartyCode || !this.externalPartyCode) return
      const self = this
      if (value == 1) {
        this.cancel.removeTalkback && this.cancel.removeTalkback()
      } else {
        this.cancel.addTalkback && this.cancel.addTalkback()
      }
      const params = [
        {
          annotation: this.externalPartyCode,
          initiator: this.realPartyCode,
          key,
          mark: this.userInfo.rtilCode + '',
          notify: true,
          value
        },
        {
          annotation: this.externalPartyCode,
          initiator: this.realPartyCode,
          key: 'audioStatus',
          mark: this.userInfo.rtilCode + '',
          notify: true,
          value: this.hadPushTalk
        }
      ]
      this.$http
        .post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/setList`, params, {
          cancelToken: new CancelToken(function executor (c) {
            self.cancel[value == 1 ? 'addTalkback' : 'removeTalkback'] = c
            // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
          })
        })
        .then(() => {})
        .catch(() => {})
    },
    refreshPage () {
      window.location.reload()
    },
    leaveParty () {
      const params = {
        partyCode: this.userInfo.joinCode,
        module: 'leaveParty',
        msg: {
          rtilCode: this.userInfo.rtilCode,
          realPartyCode: this.userInfo.realPartyCode,
          externalParty: this.userInfo?.externalJoinInfo?.join
        }
      }
      if (!params.partyCode || !params.msg.rtilCode) return
      this.$http.post(
        `${this.State.config.urlInfo.partyline}/partyline-backend/party/noLogin/command?key=11260`,
        params
      ).then(res => {
        if (res.data.errorCode === '0x0') {
          this.deleteChannels()
        }
      })
      this.$router.push({ name: 'leaveParty' }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          console.error('导航失败:', error)
        }
      })
    }
  },
  beforeDestroy () {
    this.socket && this.socket.off()
    this.websockets.forEach(ws => ws && ws.off())
    this.websockets = []
    clearTimeout(this.speakTimer)
    clearTimeout(this.silenceTimer)
  },
  async beforeRouteLeave (to, from, next) {
    window.removeEventListener('keydown', this.keyDownEvent)
    window.removeEventListener('keyup', this.keyupEvent)
    next()
    if (this.rtc) {
      for (const k in this.rtc) {
        if (this.hadOpenWebCloud) {
          try {
            this.rtc[k] && await this.rtc[k].leave(this.hadOpenWebCloud ? 'closeCLoudProxy' : '')
          } catch (e) {
            console.warn('[RTC] leave error during route change:', e.message)
          }
        }
      }
    }
    this.hadOpenWebCloud = false
  }
}
</script>
<style lang="less" scoped>
#box {
  .delayWarn {
    height: 40px;
    line-height: 40px;
    background: #03897b;
    text-indent: 25px;
    position: absolute;
    width: 100%;
    z-index: 2;
    i {
      margin-right: 5px;
    }
    ::v-deep .el-button {
      padding: 9px 10px;
      margin-left: 100px;
      background: #015249;
      color: #fff;
      border: none;
      &:hover {
        background: #02413a;
      }
    }
  }
}
#content {
  height: calc(100% - 120px);
  display: flex;
  ::v-deep .metaData {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 2;
    text-shadow:
        -1px -1px 0 #000,
         1px -1px 0 #000,
        -1px  1px 0 #000,
         1px  1px 0 #000;
  }
  ::v-deep .pipParams {
    font-size: 13px;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 2px;
    z-index: 2;
    text-shadow:
        -1px -1px 0 #000,
         1px -1px 0 #000,
        -1px  1px 0 #000,
         1px  1px 0 #000;
  }
  ::v-deep .group-box {
    &:nth-child(1) {
      width: 85%;
      margin-right: 0;
      .content-box {
        padding: 0;
        .pip {
          padding: 0 0 0 10px;
          .video-con {
            max-height: calc(100vh - 145px);
            .videoBox {
              video {
                object-fit: contain!important;
              }
            }
          }
          .volumeBox {
            max-height: calc(100vh - 145px);
          }
        }
      }
    }
    &:nth-child(2) {
      width: 15%;
      margin-right: 0;
      margin-left: -10px;
      .pip {
        padding: 0;
        li {
          >.box {
            width: calc(100% - 35px);
          }
        }
      }
    }
    .content-box {
      background: none;
      padding: 0;
      .mainWindow {
        width: 100%;
        transform: none;
        .box {
          background: #1c1c20;
        }
      }
    }
  }
  .foot {
    height: 64px;
    background: #000;
    width: 100%;
    position: fixed;
    bottom: 0;
    text-align: center;
    z-index: 2;
    .optionBox {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 2px solid #28282e;
      .icon-universal_cameraon:before,
      .icon-universal_cameraoff:before,
      .icon-speakeron:before,
      .icon-speakeroff:before,
      .hangup {
        display: block;
        width: 40px;
        height: 40px;
      }
      .feedbackBox {
        margin-left: -8px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
      }
      .feedbackDivider {
        margin: 0 40px;
      }
      .icon-a-hearself-on, .icon-a-hearself-off {
        width: 30px;
        height: 30px;
        display: block;
        color: #fff;
      }
      .metadata-controls{
        display: flex;
        align-items: center;
        .el-button{
          color: #fff;
          background: #33ab4f;
          border: 1px solid #33ab4f;
          font-weight: bold;
          &:hover {
            background: #0aa20a;
            border: 1px solid #0aa20a;
          }
        }
        .offsetContent{
          padding:10px;
        }
      }
      .cameraItem{
        display: inline-block;
      }
      .speakerItem,.cameraItem, .icon-a-hearself-on, .icon-a-hearself-off {
        font-size: 28px;
        line-height: 40px;
        background: #33AB4F;
        border:none;
        &.active {
          background: #F6445A;
        }
      }
      .icon-a-hearself-on, .icon-a-hearself-off {
        line-height: 30px;
        margin-bottom: 3px;
      }
      .micOnItem{
        margin-top: 0px !important;
        position: relative;
        .el-icon-warning{
          width: 0;
          height: 0;
          color: orange;
          position: absolute;
          border: unset;
          right: 15px;
          z-index: 1;
          top: -8px;
        }
      }
      .micOffItem{
        margin-top: 0px !important;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-around;
      }
      .talkAll{
        margin-top: 0px !important;
        display: flex;
        width: 70px !important;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        -webkit-user-select: none;
        user-select: none;
      }
      .talkHost{
        margin-left: 40px;
        margin-top: 0px !important;
        display: flex;
        width: 90px !important;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-around;
      }
      .talkPip{
        margin-left: 40px;
        margin-top: 0px !important;
        display: flex;
        width: 90px !important;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-around;
      }
      i {
        width: 40px;
        height: 40px;
        border: 1px solid #3b3b3e;
        border-radius: 50%;
        &.cameraIcon, &.muteVideo {
          margin-right: 48px;
          &.m_r_0 {
            margin-right: 0;
          }
        }
        &.cameraIcon:before {
          font-size: 20px;
        }
        &.audioIcon  {
          margin-right: 48px;
          &.m_r_0 {
            margin-right: 0;
          }
        }
        &.muteAudio,
        &.audioIcon,
        &.pushTalk {
          border: none;
          margin-top: -20px;
          position: relative;
          width: 50px;
          div {
            position: absolute;
            border: 4px solid #33AB4F;;
            opacity: 1;
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            -webkit-animation: lds-ripple 1.5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
            animation: lds-ripple 1.5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
            &:nth-child(2) {
              -webkit-animation-delay: -1s;
              animation-delay: -1s;
            }
          }
          @keyframes lds-ripple {
            0% {
              width: 0;
              height: 0;
              opacity: 1;
            }
            100% {
              width: 55px;
              height: 55px;
              opacity: 0;
            }
          }
        }
        &.icon-talkBackAll, &.icon-a-TalkbackAll, &.icon-talkBackCoord, &.icon-talkHostOff, &.icon-talkPipOff, &.icon-talkBackGroup {
          border: 0;
          height: 35px;
          font-size: 28px;
          position: relative;
          z-index: 2;
        }
        span {
          position: relative;
          top: -4px;
          font-size: 12px;
          &.btnText {
            top: -10px;
            display: block;
          }
        }
        .loading {
          width: 40px;
          height: 40px;
          top: 0px;
          display: inline-block;
          animation: loading-rotate 1s linear infinite;
        }
        .loadingHost {
          width: 40px;
          height: 40px;
          top: -34px;
          left: 11px;
          display: inline-block;
          animation: loading-rotate 1s linear infinite;
        }
      }
      .loading {
        width: 40px;
        height: 35px;
        top: 0px;
        display: inline-block;
        animation: loading-rotate 1s linear infinite;
        svg {
          width: 100%;
          height:100%;
        }
      }
      ::v-deep .el-divider--vertical {
        height: 24px;
        margin: 0 40px;
        background-color: #444;
      }
      // .leaveDivider {
      //   margin-left: -16px;
      // }
      .talkAnimation {
        position: absolute;
        border: 4px solid #33AB4F;;
        opacity: 1;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        -webkit-animation: lds-ripple 1.5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
        animation: lds-ripple 1.5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
        &:nth-child(2) {
          -webkit-animation-delay: -1s;
          animation-delay: -1s;
        }
      }
      @keyframes lds-ripple {
        0% {
          width: 0;
          height: 0;
          opacity: 1;
        }
        100% {
          width: 55px;
          height: 55px;
          opacity: 0;
        }
      }
    }
  }
}
@keyframes loading-rotate {
    to {
        transform: rotate(1turn)
    }
}
</style>
